/**
 * Generated by kubb.
 * Do not edit manually.
 * Shape Regional API
 */

/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client';
import type { RequestConfig, ResponseErrorConfig } from '../../client';
import type {
  DeleteApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
  DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema,
  DeleteApiProjectsProjectIdContractsContractIdFilesId401Schema,
  DeleteApiProjectsProjectIdContractsContractIdFilesId403Schema,
  DeleteApiProjectsProjectIdContractsContractIdFilesId404Schema,
} from '../types/deleteApiProjectsProjectIdContractsContractIdFilesIdSchema';
import type {
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId401Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId403Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId404Schema,
} from '../types/deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdSchema';
import type {
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema,
} from '../types/deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdSchema';
import type {
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationResponseSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId401Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId403Schema,
  DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId404Schema,
} from '../types/deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdSchema';
import type {
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema,
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldId401Schema,
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldId403Schema,
  DeleteApiProjectsProjectIdCustomFieldsCustomFieldId404Schema,
} from '../types/deleteApiProjectsProjectIdCustomFieldsCustomFieldIdSchema';
import type {
  DeleteApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineId401Schema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineId403Schema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineId404Schema,
  DeleteApiProjectsProjectIdDisciplinesDisciplineId422Schema,
} from '../types/deleteApiProjectsProjectIdDisciplinesDisciplineIdSchema';
import type {
  DeleteApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
  DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema,
  DeleteApiProjectsProjectIdDocumentsDocumentId401Schema,
  DeleteApiProjectsProjectIdDocumentsDocumentId403Schema,
  DeleteApiProjectsProjectIdDocumentsDocumentId404Schema,
} from '../types/deleteApiProjectsProjectIdDocumentsDocumentIdSchema';
import type {
  DeleteApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
  DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema,
  DeleteApiProjectsProjectIdGroupsGroupId401Schema,
  DeleteApiProjectsProjectIdGroupsGroupId403Schema,
  DeleteApiProjectsProjectIdGroupsGroupId404Schema,
} from '../types/deleteApiProjectsProjectIdGroupsGroupIdSchema';
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId404Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId422Schema,
} from '../types/deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdSchema';
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId404Schema,
} from '../types/deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdSchema';
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema,
} from '../types/deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdSchema';
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueId400Schema,
  DeleteApiProjectsProjectIdIssuesIssueId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueId404Schema,
} from '../types/deleteApiProjectsProjectIdIssuesIssueIdSchema';
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId403Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId404Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId422Schema,
} from '../types/deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdSchema';
import type {
  DeleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema,
  DeleteApiProjectsProjectIdIssuesIssueIdWatchings401Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdWatchings404Schema,
  DeleteApiProjectsProjectIdIssuesIssueIdWatchings422Schema,
} from '../types/deleteApiProjectsProjectIdIssuesIssueIdWatchingsSchema';
import type {
  DeleteApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewId401Schema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewId403Schema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewId404Schema,
  DeleteApiProjectsProjectIdIssueViewsIssueViewId422Schema,
} from '../types/deleteApiProjectsProjectIdIssueViewsIssueViewIdSchema';
import type {
  DeleteApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
  DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema,
  DeleteApiProjectsProjectIdLocationsLocationId401Schema,
  DeleteApiProjectsProjectIdLocationsLocationId403Schema,
  DeleteApiProjectsProjectIdLocationsLocationId404Schema,
  DeleteApiProjectsProjectIdLocationsLocationId422Schema,
} from '../types/deleteApiProjectsProjectIdLocationsLocationIdSchema';
import type {
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema,
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId401Schema,
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId403Schema,
  DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId404Schema,
} from '../types/deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdSchema';
import type {
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId401Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId403Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId404Schema,
} from '../types/deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdSchema';
import type {
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema,
} from '../types/deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionSchema';
import type {
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema,
  DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema,
} from '../types/deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdSchema';
import type {
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId401Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId403Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId404Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId422Schema,
} from '../types/deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdSchema';
import type {
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId401Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId403Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId404Schema,
} from '../types/deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdSchema';
import type {
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId401Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId403Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId404Schema,
} from '../types/deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdSchema';
import type {
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportId400Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportId401Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportId403Schema,
  DeleteApiProjectsProjectIdShiftReportsShiftReportId404Schema,
} from '../types/deleteApiProjectsProjectIdShiftReportsShiftReportIdSchema';
import type {
  DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdJoinToken401Schema,
  DeleteApiProjectsProjectIdTeamsTeamIdJoinToken403Schema,
  DeleteApiProjectsProjectIdTeamsTeamIdJoinToken404Schema,
} from '../types/deleteApiProjectsProjectIdTeamsTeamIdJoinTokenSchema';
import type {
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema,
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema,
  DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema,
} from '../types/deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdSchema';
import type {
  DeleteApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
  DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema,
  DeleteApiProjectsProjectIdTeamsTeamId401Schema,
  DeleteApiProjectsProjectIdTeamsTeamId403Schema,
  DeleteApiProjectsProjectIdTeamsTeamId404Schema,
} from '../types/deleteApiProjectsProjectIdTeamsTeamIdSchema';
import type {
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationResponseSchema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate401Schema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate403Schema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate404Schema,
} from '../types/deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateSchema';
import type {
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema,
  DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema,
} from '../types/deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSchema';
import type { GetApiConfigEnvironmentQueryResponseSchema } from '../types/getApiConfigEnvironmentSchema';
import type {
  GetApiConstructionRolesQueryResponseSchema,
  GetApiConstructionRoles401Schema,
} from '../types/getApiConstructionRolesSchema';
import type {
  GetApiNotificationsOverviewQueryResponseSchema,
  GetApiNotificationsOverview401Schema,
} from '../types/getApiNotificationsOverviewSchema';
import type {
  GetApiOrgsOrgIdQueryResponseSchema,
  GetApiOrgsOrgIdPathParamsSchema,
  GetApiOrgsOrgId401Schema,
  GetApiOrgsOrgId403Schema,
  GetApiOrgsOrgId404Schema,
} from '../types/getApiOrgsOrgIdSchema';
import type { GetApiOrgsQueryResponseSchema, GetApiOrgs401Schema } from '../types/getApiOrgsSchema';
import type {
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema,
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId401Schema,
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId403Schema,
  GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId404Schema,
} from '../types/getApiProjectsProjectIdAccessRequestsProjectAccessRequestIdSchema';
import type {
  GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
  GetApiProjectsProjectIdAccessRequestsPathParamsSchema,
  GetApiProjectsProjectIdAccessRequestsQueryParamsSchema,
  GetApiProjectsProjectIdAccessRequests400Schema,
  GetApiProjectsProjectIdAccessRequests401Schema,
  GetApiProjectsProjectIdAccessRequests403Schema,
  GetApiProjectsProjectIdAccessRequests404Schema,
} from '../types/getApiProjectsProjectIdAccessRequestsSchema';
import type {
  GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
  GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema,
  GetApiProjectsProjectIdContractsContractIdFiles401Schema,
  GetApiProjectsProjectIdContractsContractIdFiles403Schema,
  GetApiProjectsProjectIdContractsContractIdFiles404Schema,
} from '../types/getApiProjectsProjectIdContractsContractIdFilesSchema';
import type {
  GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
  GetApiProjectsProjectIdContractsContractIdPathParamsSchema,
  GetApiProjectsProjectIdContractsContractId401Schema,
  GetApiProjectsProjectIdContractsContractId403Schema,
  GetApiProjectsProjectIdContractsContractId404Schema,
} from '../types/getApiProjectsProjectIdContractsContractIdSchema';
import type {
  GetApiProjectsProjectIdContractsQueryResponseSchema,
  GetApiProjectsProjectIdContractsPathParamsSchema,
  GetApiProjectsProjectIdContracts401Schema,
  GetApiProjectsProjectIdContracts403Schema,
  GetApiProjectsProjectIdContracts404Schema,
} from '../types/getApiProjectsProjectIdContractsSchema';
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsCounters401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsCounters403Schema,
} from '../types/getApiProjectsProjectIdControlCenterChangeSignalsCountersSchema';
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes404Schema,
} from '../types/getApiProjectsProjectIdControlCenterChangeSignalsDowntimesSchema';
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsId401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsId403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsId404Schema,
} from '../types/getApiProjectsProjectIdControlCenterChangeSignalsIdSchema';
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssues401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssues403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsIssues404Schema,
} from '../types/getApiProjectsProjectIdControlCenterChangeSignalsIssuesSchema';
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs404Schema,
} from '../types/getApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSchema';
import type {
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema,
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema,
  GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema,
} from '../types/getApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSchema';
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema,
} from '../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSchema';
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed404Schema,
} from '../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedSchema';
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema,
} from '../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSchema';
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate400Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate404Schema,
} from '../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateSchema';
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView400Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView404Schema,
} from '../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewSchema';
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema,
} from '../types/getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSchema';
import type {
  GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  GetApiProjectsProjectIdControlCenterPotentialChanges401Schema,
  GetApiProjectsProjectIdControlCenterPotentialChanges403Schema,
  GetApiProjectsProjectIdControlCenterPotentialChanges404Schema,
} from '../types/getApiProjectsProjectIdControlCenterPotentialChangesSchema';
import type {
  GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
  GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema,
  GetApiProjectsProjectIdControlCenterTeamPersonalization401Schema,
  GetApiProjectsProjectIdControlCenterTeamPersonalization403Schema,
  GetApiProjectsProjectIdControlCenterTeamPersonalization404Schema,
} from '../types/getApiProjectsProjectIdControlCenterTeamPersonalizationSchema';
import type {
  GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
  GetApiProjectsProjectIdCustomFieldsPathParamsSchema,
  GetApiProjectsProjectIdCustomFields401Schema,
  GetApiProjectsProjectIdCustomFields403Schema,
  GetApiProjectsProjectIdCustomFields404Schema,
} from '../types/getApiProjectsProjectIdCustomFieldsSchema';
import type {
  GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbedding401Schema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbedding403Schema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbedding404Schema,
  GetApiProjectsProjectIdDashboardsDashboardIdEmbedding503Schema,
} from '../types/getApiProjectsProjectIdDashboardsDashboardIdEmbeddingSchema';
import type {
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues401Schema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues403Schema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues404Schema,
} from '../types/getApiProjectsProjectIdDashboardsDataHealthRecordsIssuesSchema';
import type {
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports401Schema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports403Schema,
  GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports404Schema,
} from '../types/getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsSchema';
import type {
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType401Schema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType403Schema,
  GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType404Schema,
} from '../types/getApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeSchema';
import type {
  GetApiProjectsProjectIdDashboardsQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsPathParamsSchema,
  GetApiProjectsProjectIdDashboards401Schema,
  GetApiProjectsProjectIdDashboards403Schema,
  GetApiProjectsProjectIdDashboards404Schema,
} from '../types/getApiProjectsProjectIdDashboardsSchema';
import type {
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate400Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate401Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate403Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate404Schema,
} from '../types/getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateSchema';
import type {
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities400Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities401Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities403Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities404Schema,
} from '../types/getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesSchema';
import type {
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryParamsSchema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline400Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline401Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline403Schema,
  GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline404Schema,
} from '../types/getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineSchema';
import type {
  GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
  GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema,
  GetApiProjectsProjectIdDisciplinesDisciplineId401Schema,
  GetApiProjectsProjectIdDisciplinesDisciplineId403Schema,
  GetApiProjectsProjectIdDisciplinesDisciplineId404Schema,
} from '../types/getApiProjectsProjectIdDisciplinesDisciplineIdSchema';
import type {
  GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
  GetApiProjectsProjectIdDisciplinesPathParamsSchema,
  GetApiProjectsProjectIdDisciplinesQueryParamsSchema,
  GetApiProjectsProjectIdDisciplines401Schema,
  GetApiProjectsProjectIdDisciplines403Schema,
  GetApiProjectsProjectIdDisciplines404Schema,
} from '../types/getApiProjectsProjectIdDisciplinesSchema';
import type {
  GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
  GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema,
  GetApiProjectsProjectIdDocumentsDocumentIdReferences401Schema,
  GetApiProjectsProjectIdDocumentsDocumentIdReferences403Schema,
  GetApiProjectsProjectIdDocumentsDocumentIdReferences404Schema,
} from '../types/getApiProjectsProjectIdDocumentsDocumentIdReferencesSchema';
import type {
  GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
  GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema,
  GetApiProjectsProjectIdDocumentsDocumentId401Schema,
  GetApiProjectsProjectIdDocumentsDocumentId403Schema,
  GetApiProjectsProjectIdDocumentsDocumentId404Schema,
} from '../types/getApiProjectsProjectIdDocumentsDocumentIdSchema';
import type {
  GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
  GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema,
  GetApiProjectsProjectIdDocumentsImageUrlsQueryParamsSchema,
  GetApiProjectsProjectIdDocumentsImageUrls401Schema,
  GetApiProjectsProjectIdDocumentsImageUrls403Schema,
} from '../types/getApiProjectsProjectIdDocumentsImageUrlsSchema';
import type {
  GetApiProjectsProjectIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdDocuments400Schema,
  GetApiProjectsProjectIdDocuments401Schema,
  GetApiProjectsProjectIdDocuments403Schema,
  GetApiProjectsProjectIdDocuments404Schema,
} from '../types/getApiProjectsProjectIdDocumentsSchema';
import type {
  GetApiProjectsProjectIdFilesIdQueryResponseSchema,
  GetApiProjectsProjectIdFilesIdPathParamsSchema,
  GetApiProjectsProjectIdFilesId401Schema,
  GetApiProjectsProjectIdFilesId403Schema,
  GetApiProjectsProjectIdFilesId404Schema,
} from '../types/getApiProjectsProjectIdFilesIdSchema';
import type {
  GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
  GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema,
  GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema,
  GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema,
  GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema,
} from '../types/getApiProjectsProjectIdGroupsGroupIdChannelConfigurationSchema';
import type {
  GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
  GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema,
  GetApiProjectsProjectIdGroupsGroupId401Schema,
  GetApiProjectsProjectIdGroupsGroupId403Schema,
  GetApiProjectsProjectIdGroupsGroupId404Schema,
} from '../types/getApiProjectsProjectIdGroupsGroupIdSchema';
import type {
  GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
  GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema,
  GetApiProjectsProjectIdIssuesGroupCountQueryParamsSchema,
  GetApiProjectsProjectIdIssuesGroupCount400Schema,
  GetApiProjectsProjectIdIssuesGroupCount401Schema,
  GetApiProjectsProjectIdIssuesGroupCount403Schema,
  GetApiProjectsProjectIdIssuesGroupCount404Schema,
} from '../types/getApiProjectsProjectIdIssuesGroupCountSchema';
import type {
  GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdDocuments400Schema,
  GetApiProjectsProjectIdIssuesIssueIdDocuments401Schema,
  GetApiProjectsProjectIdIssuesIssueIdDocuments403Schema,
  GetApiProjectsProjectIdIssuesIssueIdDocuments404Schema,
} from '../types/getApiProjectsProjectIdIssuesIssueIdDocumentsSchema';
import type {
  GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublic400Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublic401Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublic403Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedPublic404Schema,
} from '../types/getApiProjectsProjectIdIssuesIssueIdFeedPublicSchema';
import type {
  GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeam400Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeam401Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeam403Schema,
  GetApiProjectsProjectIdIssuesIssueIdFeedTeam404Schema,
} from '../types/getApiProjectsProjectIdIssuesIssueIdFeedTeamSchema';
import type {
  GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImages401Schema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImages403Schema,
  GetApiProjectsProjectIdIssuesIssueIdIssueImages404Schema,
} from '../types/getApiProjectsProjectIdIssuesIssueIdIssueImagesSchema';
import type {
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicators401Schema,
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicators403Schema,
  GetApiProjectsProjectIdIssuesIssueIdQualityIndicators404Schema,
} from '../types/getApiProjectsProjectIdIssuesIssueIdQualityIndicatorsSchema';
import type {
  GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueId401Schema,
  GetApiProjectsProjectIdIssuesIssueId403Schema,
  GetApiProjectsProjectIdIssuesIssueId404Schema,
} from '../types/getApiProjectsProjectIdIssuesIssueIdSchema';
import type {
  GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema,
  GetApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema,
  GetApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema,
} from '../types/getApiProjectsProjectIdIssuesIssueIdStatusStatementsSchema';
import type {
  GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdVisit401Schema,
  GetApiProjectsProjectIdIssuesIssueIdVisit403Schema,
  GetApiProjectsProjectIdIssuesIssueIdVisit404Schema,
} from '../types/getApiProjectsProjectIdIssuesIssueIdVisitSchema';
import type {
  GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
  GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema,
  GetApiProjectsProjectIdIssuesIssueIdWatchings401Schema,
  GetApiProjectsProjectIdIssuesIssueIdWatchings403Schema,
  GetApiProjectsProjectIdIssuesIssueIdWatchings404Schema,
} from '../types/getApiProjectsProjectIdIssuesIssueIdWatchingsSchema';
import type {
  GetApiProjectsProjectIdIssuesQueryResponseSchema,
  GetApiProjectsProjectIdIssuesPathParamsSchema,
  GetApiProjectsProjectIdIssuesQueryParamsSchema,
  GetApiProjectsProjectIdIssues400Schema,
  GetApiProjectsProjectIdIssues401Schema,
  GetApiProjectsProjectIdIssues403Schema,
  GetApiProjectsProjectIdIssues404Schema,
} from '../types/getApiProjectsProjectIdIssuesSchema';
import type {
  GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
  GetApiProjectsProjectIdIssueViewsPathParamsSchema,
  GetApiProjectsProjectIdIssueViews401Schema,
  GetApiProjectsProjectIdIssueViews403Schema,
  GetApiProjectsProjectIdIssueViews404Schema,
} from '../types/getApiProjectsProjectIdIssueViewsSchema';
import type {
  GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
  GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema,
  GetApiProjectsProjectIdLocationsLocationId401Schema,
  GetApiProjectsProjectIdLocationsLocationId403Schema,
  GetApiProjectsProjectIdLocationsLocationId404Schema,
} from '../types/getApiProjectsProjectIdLocationsLocationIdSchema';
import type {
  GetApiProjectsProjectIdLocationsQueryResponseSchema,
  GetApiProjectsProjectIdLocationsPathParamsSchema,
  GetApiProjectsProjectIdLocationsQueryParamsSchema,
  GetApiProjectsProjectIdLocations401Schema,
  GetApiProjectsProjectIdLocations403Schema,
  GetApiProjectsProjectIdLocations404Schema,
} from '../types/getApiProjectsProjectIdLocationsSchema';
import type {
  GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations401Schema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations404Schema,
} from '../types/getApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsSchema';
import type {
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments400Schema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments401Schema,
  GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments404Schema,
} from '../types/getApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsSchema';
import type {
  GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
  GetApiProjectsProjectIdLogsPeoplePathParamsSchema,
  GetApiProjectsProjectIdLogsPeopleQueryParamsSchema,
  GetApiProjectsProjectIdLogsPeople401Schema,
  GetApiProjectsProjectIdLogsPeople403Schema,
  GetApiProjectsProjectIdLogsPeople404Schema,
} from '../types/getApiProjectsProjectIdLogsPeopleSchema';
import type {
  GetApiProjectsProjectIdNotificationsQueryResponseSchema,
  GetApiProjectsProjectIdNotificationsPathParamsSchema,
  GetApiProjectsProjectIdNotificationsQueryParamsSchema,
  GetApiProjectsProjectIdNotifications400Schema,
  GetApiProjectsProjectIdNotifications401Schema,
  GetApiProjectsProjectIdNotifications404Schema,
} from '../types/getApiProjectsProjectIdNotificationsSchema';
import type {
  GetApiProjectsProjectIdPeopleQueryResponseSchema,
  GetApiProjectsProjectIdPeoplePathParamsSchema,
  GetApiProjectsProjectIdPeopleQueryParamsSchema,
  GetApiProjectsProjectIdPeople400Schema,
  GetApiProjectsProjectIdPeople401Schema,
  GetApiProjectsProjectIdPeople403Schema,
  GetApiProjectsProjectIdPeople404Schema,
} from '../types/getApiProjectsProjectIdPeopleSchema';
import type {
  GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
  GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema,
  GetApiProjectsProjectIdPeopleTeamMemberId401Schema,
  GetApiProjectsProjectIdPeopleTeamMemberId403Schema,
  GetApiProjectsProjectIdPeopleTeamMemberId404Schema,
} from '../types/getApiProjectsProjectIdPeopleTeamMemberIdSchema';
import type {
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema,
} from '../types/getApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSchema';
import type {
  GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema,
  GetApiProjectsProjectIdProgressLogsProgressLogId401Schema,
  GetApiProjectsProjectIdProgressLogsProgressLogId404Schema,
} from '../types/getApiProjectsProjectIdProgressLogsProgressLogIdSchema';
import type {
  GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
  GetApiProjectsProjectIdProgressLogsPathParamsSchema,
  GetApiProjectsProjectIdProgressLogsQueryParamsSchema,
  GetApiProjectsProjectIdProgressLogs401Schema,
  GetApiProjectsProjectIdProgressLogs403Schema,
  GetApiProjectsProjectIdProgressLogs404Schema,
} from '../types/getApiProjectsProjectIdProgressLogsSchema';
import type {
  GetApiProjectsProjectIdQueryResponseSchema,
  GetApiProjectsProjectIdPathParamsSchema,
  GetApiProjectsProjectId401Schema,
  GetApiProjectsProjectId403Schema,
  GetApiProjectsProjectId404Schema,
} from '../types/getApiProjectsProjectIdSchema';
import type {
  GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesQueryParamsSchema,
  GetApiProjectsProjectIdShiftActivities400Schema,
  GetApiProjectsProjectIdShiftActivities401Schema,
  GetApiProjectsProjectIdShiftActivities403Schema,
  GetApiProjectsProjectIdShiftActivities404Schema,
} from '../types/getApiProjectsProjectIdShiftActivitiesSchema';
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers404Schema,
} from '../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersSchema';
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress404Schema,
} from '../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressSchema';
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments404Schema,
} from '../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsSchema';
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema,
} from '../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSchema';
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage404Schema,
} from '../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageSchema';
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats404Schema,
} from '../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsSchema';
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema,
} from '../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdSchema';
import type {
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning401Schema,
  GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning404Schema,
} from '../types/getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningSchema';
import type {
  GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsArchivedQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsArchived400Schema,
  GetApiProjectsProjectIdShiftReportsArchived401Schema,
  GetApiProjectsProjectIdShiftReportsArchived403Schema,
  GetApiProjectsProjectIdShiftReportsArchived404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsArchivedSchema';
import type {
  GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsCompletions401Schema,
  GetApiProjectsProjectIdShiftReportsCompletions403Schema,
} from '../types/getApiProjectsProjectIdShiftReportsCompletionsSchema';
import type {
  GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsDraftQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsDraft400Schema,
  GetApiProjectsProjectIdShiftReportsDraft401Schema,
  GetApiProjectsProjectIdShiftReportsDraft403Schema,
  GetApiProjectsProjectIdShiftReportsDraft404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsDraftSchema';
import type {
  GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsInReviewQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsInReview400Schema,
  GetApiProjectsProjectIdShiftReportsInReview401Schema,
  GetApiProjectsProjectIdShiftReportsInReview403Schema,
  GetApiProjectsProjectIdShiftReportsInReview404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsInReviewSchema';
import type {
  GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsQueryParamsSchema,
  GetApiProjectsProjectIdShiftReports400Schema,
  GetApiProjectsProjectIdShiftReports401Schema,
  GetApiProjectsProjectIdShiftReports403Schema,
  GetApiProjectsProjectIdShiftReports404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsSchema';
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSchema';
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSchema';
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSchema';
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeople401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeople403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPeople404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsShiftReportIdPeopleSchema';
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersSchema';
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsSchema';
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSchema';
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSchema';
import type {
  GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema,
  GetApiProjectsProjectIdShiftReportsShiftReportId401Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportId403Schema,
  GetApiProjectsProjectIdShiftReportsShiftReportId404Schema,
} from '../types/getApiProjectsProjectIdShiftReportsShiftReportIdSchema';
import type {
  GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
  GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema,
  GetApiProjectsProjectIdTeamJoinTokensToken404Schema,
} from '../types/getApiProjectsProjectIdTeamJoinTokensTokenSchema';
import type {
  GetApiProjectsProjectIdTeamsQueryResponseSchema,
  GetApiProjectsProjectIdTeamsPathParamsSchema,
  GetApiProjectsProjectIdTeams401Schema,
  GetApiProjectsProjectIdTeams403Schema,
  GetApiProjectsProjectIdTeams404Schema,
} from '../types/getApiProjectsProjectIdTeamsSchema';
import type {
  GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema,
  GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema,
  GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema,
} from '../types/getApiProjectsProjectIdTeamsTeamIdChannelConfigurationSchema';
import type {
  GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdJoinToken401Schema,
  GetApiProjectsProjectIdTeamsTeamIdJoinToken403Schema,
  GetApiProjectsProjectIdTeamsTeamIdJoinToken404Schema,
} from '../types/getApiProjectsProjectIdTeamsTeamIdJoinTokenSchema';
import type {
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies401Schema,
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies403Schema,
  GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies404Schema,
} from '../types/getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesSchema';
import type {
  GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema,
  GetApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema,
} from '../types/getApiProjectsProjectIdTeamsTeamIdResourcesKindSchema';
import type {
  GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamId401Schema,
  GetApiProjectsProjectIdTeamsTeamId403Schema,
  GetApiProjectsProjectIdTeamsTeamId404Schema,
} from '../types/getApiProjectsProjectIdTeamsTeamIdSchema';
import type {
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema,
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan401Schema,
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan403Schema,
  GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan404Schema,
} from '../types/getApiProjectsProjectIdTeamsTeamIdSubscriptionPlanSchema';
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansQueryParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlans400Schema,
  GetApiProjectsProjectIdWeeklyWorkPlans401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlans403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlans404Schema,
} from '../types/getApiProjectsProjectIdWeeklyWorkPlansSchema';
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema,
} from '../types/getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSchema';
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema,
} from '../types/getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSchema';
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema,
} from '../types/getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSchema';
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs404Schema,
} from '../types/getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsSchema';
import type {
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema,
  GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema,
} from '../types/getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSchema';
import type {
  GetApiProjectsQueryResponseSchema,
  GetApiProjects401Schema,
  GetApiProjects403Schema,
} from '../types/getApiProjectsSchema';
import type {
  GetApiQueuedTasksQueryResponseSchema,
  GetApiQueuedTasksQueryParamsSchema,
  GetApiQueuedTasks400Schema,
  GetApiQueuedTasks401Schema,
} from '../types/getApiQueuedTasksSchema';
import type {
  GetWellKnownJwksJsonQueryResponseSchema,
  GetWellKnownJwksJson503Schema,
} from '../types/getWellKnownJwksJsonSchema';
import type {
  PatchApiOrgsOrgIdMutationRequestSchema,
  PatchApiOrgsOrgIdMutationResponseSchema,
  PatchApiOrgsOrgIdPathParamsSchema,
  PatchApiOrgsOrgId401Schema,
} from '../types/patchApiOrgsOrgIdSchema';
import type {
  PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema,
  PatchApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
  PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema,
  PatchApiProjectsProjectIdContractsContractIdFilesId401Schema,
  PatchApiProjectsProjectIdContractsContractIdFilesId403Schema,
  PatchApiProjectsProjectIdContractsContractIdFilesId404Schema,
  PatchApiProjectsProjectIdContractsContractIdFilesId422Schema,
} from '../types/patchApiProjectsProjectIdContractsContractIdFilesIdSchema';
import type {
  PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema,
  PatchApiProjectsProjectIdContractsContractIdMutationResponseSchema,
  PatchApiProjectsProjectIdContractsContractIdPathParamsSchema,
  PatchApiProjectsProjectIdContractsContractId401Schema,
  PatchApiProjectsProjectIdContractsContractId403Schema,
  PatchApiProjectsProjectIdContractsContractId422Schema,
} from '../types/patchApiProjectsProjectIdContractsContractIdSchema';
import type {
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema,
  PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter422Schema,
} from '../types/patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterSchema';
import type {
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative400Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema,
} from '../types/patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeSchema';
import type {
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId400Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId422Schema,
} from '../types/patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdSchema';
import type {
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema,
  PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId422Schema,
} from '../types/patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdSchema';
import type {
  PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationResponseSchema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalization401Schema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalization403Schema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalization404Schema,
  PatchApiProjectsProjectIdControlCenterTeamPersonalization422Schema,
} from '../types/patchApiProjectsProjectIdControlCenterTeamPersonalizationSchema';
import type {
  PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldId401Schema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldId403Schema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldId404Schema,
  PatchApiProjectsProjectIdCustomFieldsCustomFieldId422Schema,
} from '../types/patchApiProjectsProjectIdCustomFieldsCustomFieldIdSchema';
import type {
  PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema,
  PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
  PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema,
  PatchApiProjectsProjectIdDisciplinesDisciplineId401Schema,
  PatchApiProjectsProjectIdDisciplinesDisciplineId403Schema,
  PatchApiProjectsProjectIdDisciplinesDisciplineId404Schema,
  PatchApiProjectsProjectIdDisciplinesDisciplineId422Schema,
} from '../types/patchApiProjectsProjectIdDisciplinesDisciplineIdSchema';
import type {
  PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema,
  PatchApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
  PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema,
  PatchApiProjectsProjectIdDocumentsDocumentId401Schema,
  PatchApiProjectsProjectIdDocumentsDocumentId403Schema,
  PatchApiProjectsProjectIdDocumentsDocumentId404Schema,
  PatchApiProjectsProjectIdDocumentsDocumentId422Schema,
} from '../types/patchApiProjectsProjectIdDocumentsDocumentIdSchema';
import type {
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationResponseSchema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema,
  PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration422Schema,
} from '../types/patchApiProjectsProjectIdGroupsGroupIdChannelConfigurationSchema';
import type {
  PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema,
  PatchApiProjectsProjectIdGroupsGroupIdMembersMutationResponseSchema,
  PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema,
  PatchApiProjectsProjectIdGroupsGroupIdMembers401Schema,
  PatchApiProjectsProjectIdGroupsGroupIdMembers403Schema,
  PatchApiProjectsProjectIdGroupsGroupIdMembers404Schema,
  PatchApiProjectsProjectIdGroupsGroupIdMembers422Schema,
} from '../types/patchApiProjectsProjectIdGroupsGroupIdMembersSchema';
import type {
  PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema,
  PatchApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
  PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema,
  PatchApiProjectsProjectIdGroupsGroupId400Schema,
  PatchApiProjectsProjectIdGroupsGroupId401Schema,
  PatchApiProjectsProjectIdGroupsGroupId403Schema,
  PatchApiProjectsProjectIdGroupsGroupId404Schema,
  PatchApiProjectsProjectIdGroupsGroupId422Schema,
} from '../types/patchApiProjectsProjectIdGroupsGroupIdSchema';
import type {
  PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationResponseSchema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFields401Schema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFields403Schema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFields404Schema,
  PatchApiProjectsProjectIdIssuesIssueIdCustomFields422Schema,
} from '../types/patchApiProjectsProjectIdIssuesIssueIdCustomFieldsSchema';
import type {
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema,
  PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema,
} from '../types/patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdSchema';
import type {
  PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema,
  PatchApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
  PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema,
  PatchApiProjectsProjectIdIssuesIssueId401Schema,
  PatchApiProjectsProjectIdIssuesIssueId403Schema,
  PatchApiProjectsProjectIdIssuesIssueId404Schema,
  PatchApiProjectsProjectIdIssuesIssueId422Schema,
} from '../types/patchApiProjectsProjectIdIssuesIssueIdSchema';
import type {
  PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema,
  PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
  PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema,
  PatchApiProjectsProjectIdIssueViewsIssueViewId401Schema,
  PatchApiProjectsProjectIdIssueViewsIssueViewId403Schema,
  PatchApiProjectsProjectIdIssueViewsIssueViewId404Schema,
  PatchApiProjectsProjectIdIssueViewsIssueViewId422Schema,
} from '../types/patchApiProjectsProjectIdIssueViewsIssueViewIdSchema';
import type {
  PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema,
  PatchApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
  PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema,
  PatchApiProjectsProjectIdLocationsLocationId401Schema,
  PatchApiProjectsProjectIdLocationsLocationId403Schema,
  PatchApiProjectsProjectIdLocationsLocationId404Schema,
  PatchApiProjectsProjectIdLocationsLocationId422Schema,
} from '../types/patchApiProjectsProjectIdLocationsLocationIdSchema';
import type {
  PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema,
  PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationResponseSchema,
  PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema,
  PatchApiProjectsProjectIdProgressLogsProgressLogId401Schema,
  PatchApiProjectsProjectIdProgressLogsProgressLogId403Schema,
  PatchApiProjectsProjectIdProgressLogsProgressLogId404Schema,
  PatchApiProjectsProjectIdProgressLogsProgressLogId422Schema,
} from '../types/patchApiProjectsProjectIdProgressLogsProgressLogIdSchema';
import type {
  PatchApiProjectsProjectIdMutationRequestSchema,
  PatchApiProjectsProjectIdMutationResponseSchema,
  PatchApiProjectsProjectIdPathParamsSchema,
  PatchApiProjectsProjectId401Schema,
  PatchApiProjectsProjectId403Schema,
  PatchApiProjectsProjectId404Schema,
  PatchApiProjectsProjectId422Schema,
} from '../types/patchApiProjectsProjectIdSchema';
import type {
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationResponseSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness400Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness401Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness403Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness404Schema,
} from '../types/patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessSchema';
import type {
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId422Schema,
} from '../types/patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdSchema';
import type {
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationResponseSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityId403Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema,
  PatchApiProjectsProjectIdShiftActivitiesShiftActivityId422Schema,
} from '../types/patchApiProjectsProjectIdShiftActivitiesShiftActivityIdSchema';
import type {
  PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema,
  PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
  PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId400Schema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId401Schema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId403Schema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId404Schema,
  PatchApiProjectsProjectIdShiftReportsShiftReportId422Schema,
} from '../types/patchApiProjectsProjectIdShiftReportsShiftReportIdSchema';
import type {
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationResponseSchema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema,
  PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration422Schema,
} from '../types/patchApiProjectsProjectIdTeamsTeamIdChannelConfigurationSchema';
import type {
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema,
  PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId422Schema,
} from '../types/patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdSchema';
import type {
  PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema,
  PatchApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
  PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema,
  PatchApiProjectsProjectIdTeamsTeamId401Schema,
  PatchApiProjectsProjectIdTeamsTeamId403Schema,
  PatchApiProjectsProjectIdTeamsTeamId404Schema,
} from '../types/patchApiProjectsProjectIdTeamsTeamIdSchema';
import type {
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationResponseSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder422Schema,
} from '../types/patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderSchema';
import type {
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema,
  PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId422Schema,
} from '../types/patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdSchema';
import type {
  PostApiChannelsTokenMutationResponseSchema,
  PostApiChannelsToken401Schema,
  PostApiChannelsToken422Schema,
  PostApiChannelsToken503Schema,
} from '../types/postApiChannelsTokenSchema';
import type {
  PostApiDirectUploadsTypeMutationRequestSchema,
  PostApiDirectUploadsTypeMutationResponseSchema,
  PostApiDirectUploadsTypePathParamsSchema,
  PostApiDirectUploadsType400Schema,
  PostApiDirectUploadsType401Schema,
  PostApiDirectUploadsType404Schema,
} from '../types/postApiDirectUploadsTypeSchema';
import type {
  PostApiOrgsCheckDomainMutationRequestSchema,
  PostApiOrgsCheckDomainMutationResponseSchema,
  PostApiOrgsCheckDomain401Schema,
} from '../types/postApiOrgsCheckDomainSchema';
import type {
  PostApiOrgsOrgIdResendVerificationEmailMutationResponseSchema,
  PostApiOrgsOrgIdResendVerificationEmailPathParamsSchema,
  PostApiOrgsOrgIdResendVerificationEmail401Schema,
  PostApiOrgsOrgIdResendVerificationEmail403Schema,
  PostApiOrgsOrgIdResendVerificationEmail404Schema,
} from '../types/postApiOrgsOrgIdResendVerificationEmailSchema';
import type {
  PostApiOrgsMutationRequestSchema,
  PostApiOrgsMutationResponseSchema,
  PostApiOrgs400Schema,
  PostApiOrgs401Schema,
  PostApiOrgs422Schema,
} from '../types/postApiOrgsSchema';
import type {
  PostApiPowerSyncTokenMutationResponseSchema,
  PostApiPowerSyncToken401Schema,
} from '../types/postApiPowerSyncTokenSchema';
import type {
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationResponseSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept401Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept403Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept404Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept422Schema,
} from '../types/postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptSchema';
import type {
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationResponseSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect400Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect401Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect403Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect404Schema,
} from '../types/postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectSchema';
import type {
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationResponseSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject401Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject403Schema,
  PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject404Schema,
} from '../types/postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectSchema';
import type {
  PostApiProjectsProjectIdAccessRequestsMutationRequestSchema,
  PostApiProjectsProjectIdAccessRequestsMutationResponseSchema,
  PostApiProjectsProjectIdAccessRequestsPathParamsSchema,
  PostApiProjectsProjectIdAccessRequests400Schema,
  PostApiProjectsProjectIdAccessRequests401Schema,
  PostApiProjectsProjectIdAccessRequests404Schema,
  PostApiProjectsProjectIdAccessRequests422Schema,
} from '../types/postApiProjectsProjectIdAccessRequestsSchema';
import type {
  PostApiProjectsProjectIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdArchivePathParamsSchema,
  PostApiProjectsProjectIdArchive401Schema,
  PostApiProjectsProjectIdArchive403Schema,
  PostApiProjectsProjectIdArchive404Schema,
} from '../types/postApiProjectsProjectIdArchiveSchema';
import type {
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationResponseSchema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments401Schema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments403Schema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments404Schema,
  PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments422Schema,
} from '../types/postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsSchema';
import type {
  PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema,
  PostApiProjectsProjectIdChannelsMessagingMutationResponseSchema,
  PostApiProjectsProjectIdChannelsMessagingPathParamsSchema,
  PostApiProjectsProjectIdChannelsMessaging400Schema,
  PostApiProjectsProjectIdChannelsMessaging401Schema,
  PostApiProjectsProjectIdChannelsMessaging403Schema,
  PostApiProjectsProjectIdChannelsMessaging404Schema,
  PostApiProjectsProjectIdChannelsMessaging422Schema,
} from '../types/postApiProjectsProjectIdChannelsMessagingSchema';
import type {
  PostApiProjectsProjectIdChannelsPersonalMutationResponseSchema,
  PostApiProjectsProjectIdChannelsPersonalPathParamsSchema,
  PostApiProjectsProjectIdChannelsPersonal401Schema,
  PostApiProjectsProjectIdChannelsPersonal403Schema,
  PostApiProjectsProjectIdChannelsPersonal404Schema,
  PostApiProjectsProjectIdChannelsPersonal422Schema,
} from '../types/postApiProjectsProjectIdChannelsPersonalSchema';
import type {
  PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema,
  PostApiProjectsProjectIdContractsContractIdFilesMutationResponseSchema,
  PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema,
  PostApiProjectsProjectIdContractsContractIdFiles400Schema,
  PostApiProjectsProjectIdContractsContractIdFiles401Schema,
  PostApiProjectsProjectIdContractsContractIdFiles403Schema,
  PostApiProjectsProjectIdContractsContractIdFiles404Schema,
  PostApiProjectsProjectIdContractsContractIdFiles422Schema,
} from '../types/postApiProjectsProjectIdContractsContractIdFilesSchema';
import type {
  PostApiProjectsProjectIdContractsMutationRequestSchema,
  PostApiProjectsProjectIdContractsMutationResponseSchema,
  PostApiProjectsProjectIdContractsPathParamsSchema,
  PostApiProjectsProjectIdContracts401Schema,
  PostApiProjectsProjectIdContracts403Schema,
  PostApiProjectsProjectIdContracts422Schema,
} from '../types/postApiProjectsProjectIdContractsSchema';
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss404Schema,
} from '../types/postApiProjectsProjectIdControlCenterChangeSignalsBatchDismissSchema';
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals404Schema,
} from '../types/postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsSchema';
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch404Schema,
} from '../types/postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchSchema';
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch404Schema,
} from '../types/postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchSchema';
import type {
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchPathParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch401Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch403Schema,
  PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch404Schema,
} from '../types/postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchSchema';
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive404Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive422Schema,
} from '../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveSchema';
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate403Schema,
} from '../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateSchema';
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete403Schema,
} from '../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteSchema';
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments422Schema,
} from '../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsSchema';
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport404Schema,
} from '../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportSchema';
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile400Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile404Schema,
} from '../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileSchema';
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries400Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries404Schema,
} from '../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesSchema';
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows404Schema,
} from '../types/postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsSchema';
import type {
  PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesMutationResponseSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  PostApiProjectsProjectIdControlCenterPotentialChanges401Schema,
  PostApiProjectsProjectIdControlCenterPotentialChanges403Schema,
  PostApiProjectsProjectIdControlCenterPotentialChanges404Schema,
  PostApiProjectsProjectIdControlCenterPotentialChanges422Schema,
} from '../types/postApiProjectsProjectIdControlCenterPotentialChangesSchema';
import type {
  PostApiProjectsProjectIdCustomFieldsMutationRequestSchema,
  PostApiProjectsProjectIdCustomFieldsMutationResponseSchema,
  PostApiProjectsProjectIdCustomFieldsPathParamsSchema,
  PostApiProjectsProjectIdCustomFields401Schema,
  PostApiProjectsProjectIdCustomFields403Schema,
  PostApiProjectsProjectIdCustomFields404Schema,
  PostApiProjectsProjectIdCustomFields422Schema,
} from '../types/postApiProjectsProjectIdCustomFieldsSchema';
import type {
  PostApiProjectsProjectIdDisciplinesMutationRequestSchema,
  PostApiProjectsProjectIdDisciplinesMutationResponseSchema,
  PostApiProjectsProjectIdDisciplinesPathParamsSchema,
  PostApiProjectsProjectIdDisciplines401Schema,
  PostApiProjectsProjectIdDisciplines403Schema,
  PostApiProjectsProjectIdDisciplines404Schema,
  PostApiProjectsProjectIdDisciplines422Schema,
} from '../types/postApiProjectsProjectIdDisciplinesSchema';
import type {
  PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema,
  PostApiProjectsProjectIdDisciplinesSortMutationResponseSchema,
  PostApiProjectsProjectIdDisciplinesSortPathParamsSchema,
  PostApiProjectsProjectIdDisciplinesSort401Schema,
  PostApiProjectsProjectIdDisciplinesSort403Schema,
  PostApiProjectsProjectIdDisciplinesSort404Schema,
} from '../types/postApiProjectsProjectIdDisciplinesSortSchema';
import type {
  PostApiProjectsProjectIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdDocuments400Schema,
  PostApiProjectsProjectIdDocuments401Schema,
  PostApiProjectsProjectIdDocuments403Schema,
  PostApiProjectsProjectIdDocuments404Schema,
  PostApiProjectsProjectIdDocuments422Schema,
} from '../types/postApiProjectsProjectIdDocumentsSchema';
import type {
  PostApiProjectsProjectIdGroupsMutationRequestSchema,
  PostApiProjectsProjectIdGroupsMutationResponseSchema,
  PostApiProjectsProjectIdGroupsPathParamsSchema,
  PostApiProjectsProjectIdGroups400Schema,
  PostApiProjectsProjectIdGroups401Schema,
  PostApiProjectsProjectIdGroups403Schema,
  PostApiProjectsProjectIdGroups404Schema,
  PostApiProjectsProjectIdGroups422Schema,
} from '../types/postApiProjectsProjectIdGroupsSchema';
import type {
  PostApiProjectsProjectIdIssuesExportMutationResponseSchema,
  PostApiProjectsProjectIdIssuesExportPathParamsSchema,
  PostApiProjectsProjectIdIssuesExportQueryParamsSchema,
  PostApiProjectsProjectIdIssuesExport400Schema,
  PostApiProjectsProjectIdIssuesExport401Schema,
  PostApiProjectsProjectIdIssuesExport403Schema,
  PostApiProjectsProjectIdIssuesExport404Schema,
} from '../types/postApiProjectsProjectIdIssuesExportSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdApproveMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdApprove400Schema,
  PostApiProjectsProjectIdIssuesIssueIdApprove401Schema,
  PostApiProjectsProjectIdIssuesIssueIdApprove403Schema,
  PostApiProjectsProjectIdIssuesIssueIdApprove404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdApproveSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdArchive401Schema,
  PostApiProjectsProjectIdIssuesIssueIdArchive403Schema,
  PostApiProjectsProjectIdIssuesIssueIdArchive404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdArchiveSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept401Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept403Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject401Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject403Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdAssignments400Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignments401Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignments403Schema,
  PostApiProjectsProjectIdIssuesIssueIdAssignments404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdAssignmentsSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdCommentsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdComments401Schema,
  PostApiProjectsProjectIdIssuesIssueIdComments403Schema,
  PostApiProjectsProjectIdIssuesIssueIdComments404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdCommentsSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdCompleteMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdComplete400Schema,
  PostApiProjectsProjectIdIssuesIssueIdComplete401Schema,
  PostApiProjectsProjectIdIssuesIssueIdComplete403Schema,
  PostApiProjectsProjectIdIssuesIssueIdComplete404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdCompleteSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdDocuments400Schema,
  PostApiProjectsProjectIdIssuesIssueIdDocuments401Schema,
  PostApiProjectsProjectIdIssuesIssueIdDocuments403Schema,
  PostApiProjectsProjectIdIssuesIssueIdDocuments422Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdDocumentsSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdExportMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdExport401Schema,
  PostApiProjectsProjectIdIssuesIssueIdExport403Schema,
  PostApiProjectsProjectIdIssuesIssueIdExport404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdExportSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImages400Schema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImages401Schema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImages403Schema,
  PostApiProjectsProjectIdIssuesIssueIdIssueImages422Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdIssueImagesSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdRejectMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdReject400Schema,
  PostApiProjectsProjectIdIssuesIssueIdReject401Schema,
  PostApiProjectsProjectIdIssuesIssueIdReject403Schema,
  PostApiProjectsProjectIdIssuesIssueIdReject404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdRejectSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdReopenMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdReopen400Schema,
  PostApiProjectsProjectIdIssuesIssueIdReopen401Schema,
  PostApiProjectsProjectIdIssuesIssueIdReopen403Schema,
  PostApiProjectsProjectIdIssuesIssueIdReopen404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdReopenSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdRestoreMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdRestore401Schema,
  PostApiProjectsProjectIdIssuesIssueIdRestore403Schema,
  PostApiProjectsProjectIdIssuesIssueIdRestore404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdRestoreSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdStartMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdStart400Schema,
  PostApiProjectsProjectIdIssuesIssueIdStart401Schema,
  PostApiProjectsProjectIdIssuesIssueIdStart403Schema,
  PostApiProjectsProjectIdIssuesIssueIdStart404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdStartSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema,
  PostApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdStatusStatementsSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdStopMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdStop400Schema,
  PostApiProjectsProjectIdIssuesIssueIdStop401Schema,
  PostApiProjectsProjectIdIssuesIssueIdStop403Schema,
  PostApiProjectsProjectIdIssuesIssueIdStop404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdStopSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdSubmitMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdSubmit401Schema,
  PostApiProjectsProjectIdIssuesIssueIdSubmit403Schema,
  PostApiProjectsProjectIdIssuesIssueIdSubmit404Schema,
  PostApiProjectsProjectIdIssuesIssueIdSubmit422Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdSubmitSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpact401Schema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpact403Schema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpact404Schema,
  PostApiProjectsProjectIdIssuesIssueIdUpdateImpact422Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdUpdateImpactSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdVisitMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdVisit401Schema,
  PostApiProjectsProjectIdIssuesIssueIdVisit403Schema,
  PostApiProjectsProjectIdIssuesIssueIdVisit404Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdVisitSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate401Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate403Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate422Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateSchema';
import type {
  PostApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema,
  PostApiProjectsProjectIdIssuesIssueIdWatchings401Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchings403Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchings404Schema,
  PostApiProjectsProjectIdIssuesIssueIdWatchings422Schema,
} from '../types/postApiProjectsProjectIdIssuesIssueIdWatchingsSchema';
import type {
  PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema,
  PostApiProjectsProjectIdIssuesQuickIssuesMutationResponseSchema,
  PostApiProjectsProjectIdIssuesQuickIssuesPathParamsSchema,
  PostApiProjectsProjectIdIssuesQuickIssuesHeaderParamsSchema,
  PostApiProjectsProjectIdIssuesQuickIssues400Schema,
  PostApiProjectsProjectIdIssuesQuickIssues401Schema,
  PostApiProjectsProjectIdIssuesQuickIssues403Schema,
  PostApiProjectsProjectIdIssuesQuickIssues404Schema,
  PostApiProjectsProjectIdIssuesQuickIssues422Schema,
} from '../types/postApiProjectsProjectIdIssuesQuickIssuesSchema';
import type {
  PostApiProjectsProjectIdIssuesMutationRequestSchema,
  PostApiProjectsProjectIdIssuesMutationResponseSchema,
  PostApiProjectsProjectIdIssuesPathParamsSchema,
  PostApiProjectsProjectIdIssuesHeaderParamsSchema,
  PostApiProjectsProjectIdIssues401Schema,
  PostApiProjectsProjectIdIssues403Schema,
  PostApiProjectsProjectIdIssues404Schema,
} from '../types/postApiProjectsProjectIdIssuesSchema';
import type {
  PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema,
  PostApiProjectsProjectIdIssuesSmartIssuesMutationResponseSchema,
  PostApiProjectsProjectIdIssuesSmartIssuesPathParamsSchema,
  PostApiProjectsProjectIdIssuesSmartIssues401Schema,
  PostApiProjectsProjectIdIssuesSmartIssues403Schema,
  PostApiProjectsProjectIdIssuesSmartIssues404Schema,
} from '../types/postApiProjectsProjectIdIssuesSmartIssuesSchema';
import type {
  PostApiProjectsProjectIdIssueViewsMutationRequestSchema,
  PostApiProjectsProjectIdIssueViewsMutationResponseSchema,
  PostApiProjectsProjectIdIssueViewsPathParamsSchema,
  PostApiProjectsProjectIdIssueViews401Schema,
  PostApiProjectsProjectIdIssueViews403Schema,
  PostApiProjectsProjectIdIssueViews404Schema,
  PostApiProjectsProjectIdIssueViews422Schema,
} from '../types/postApiProjectsProjectIdIssueViewsSchema';
import type {
  PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema,
  PostApiProjectsProjectIdLocationsLocationIdSortMutationResponseSchema,
  PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema,
  PostApiProjectsProjectIdLocationsLocationIdSort401Schema,
  PostApiProjectsProjectIdLocationsLocationIdSort403Schema,
  PostApiProjectsProjectIdLocationsLocationIdSort404Schema,
} from '../types/postApiProjectsProjectIdLocationsLocationIdSortSchema';
import type {
  PostApiProjectsProjectIdLocationsMutationRequestSchema,
  PostApiProjectsProjectIdLocationsMutationResponseSchema,
  PostApiProjectsProjectIdLocationsPathParamsSchema,
  PostApiProjectsProjectIdLocations401Schema,
  PostApiProjectsProjectIdLocations403Schema,
  PostApiProjectsProjectIdLocations404Schema,
  PostApiProjectsProjectIdLocations422Schema,
} from '../types/postApiProjectsProjectIdLocationsSchema';
import type {
  PostApiProjectsProjectIdNotificationsMarkAllReadMutationResponseSchema,
  PostApiProjectsProjectIdNotificationsMarkAllReadPathParamsSchema,
  PostApiProjectsProjectIdNotificationsMarkAllRead401Schema,
} from '../types/postApiProjectsProjectIdNotificationsMarkAllReadSchema';
import type {
  PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema,
  PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationResponseSchema,
  PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema,
  PostApiProjectsProjectIdNotificationsNotificationIdMarkRead401Schema,
  PostApiProjectsProjectIdNotificationsNotificationIdMarkRead404Schema,
} from '../types/postApiProjectsProjectIdNotificationsNotificationIdMarkReadSchema';
import type {
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema,
  PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments422Schema,
} from '../types/postApiProjectsProjectIdProgressLogsProgressLogIdDocumentsSchema';
import type {
  PostApiProjectsProjectIdProgressLogsMutationRequestSchema,
  PostApiProjectsProjectIdProgressLogsMutationResponseSchema,
  PostApiProjectsProjectIdProgressLogsPathParamsSchema,
  PostApiProjectsProjectIdProgressLogs401Schema,
  PostApiProjectsProjectIdProgressLogs403Schema,
  PostApiProjectsProjectIdProgressLogs404Schema,
  PostApiProjectsProjectIdProgressLogs422Schema,
} from '../types/postApiProjectsProjectIdProgressLogsSchema';
import type {
  PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesExportMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesExportPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesExport401Schema,
  PostApiProjectsProjectIdShiftActivitiesExport403Schema,
  PostApiProjectsProjectIdShiftActivitiesExport404Schema,
} from '../types/postApiProjectsProjectIdShiftActivitiesExportSchema';
import type {
  PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesImportsMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesImportsPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesImports401Schema,
  PostApiProjectsProjectIdShiftActivitiesImports403Schema,
  PostApiProjectsProjectIdShiftActivitiesImports404Schema,
  PostApiProjectsProjectIdShiftActivitiesImports422Schema,
} from '../types/postApiProjectsProjectIdShiftActivitiesImportsSchema';
import type {
  PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesPathParamsSchema,
  PostApiProjectsProjectIdShiftActivities401Schema,
  PostApiProjectsProjectIdShiftActivities403Schema,
  PostApiProjectsProjectIdShiftActivities404Schema,
  PostApiProjectsProjectIdShiftActivities422Schema,
} from '../types/postApiProjectsProjectIdShiftActivitiesSchema';
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive404Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive422Schema,
} from '../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveSchema';
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch400Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch404Schema,
} from '../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchSchema';
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema,
} from '../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionSchema';
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements422Schema,
} from '../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSchema';
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort400Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort404Schema,
} from '../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortSchema';
import type {
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationResponseSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore401Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore403Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore404Schema,
  PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore422Schema,
} from '../types/postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreSchema';
import type {
  PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsExportMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsExportPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsExport400Schema,
  PostApiProjectsProjectIdShiftReportsExport401Schema,
  PostApiProjectsProjectIdShiftReportsExport403Schema,
  PostApiProjectsProjectIdShiftReportsExport404Schema,
} from '../types/postApiProjectsProjectIdShiftReportsExportSchema';
import type {
  PostApiProjectsProjectIdShiftReportsMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsPathParamsSchema,
  PostApiProjectsProjectIdShiftReports401Schema,
  PostApiProjectsProjectIdShiftReports403Schema,
  PostApiProjectsProjectIdShiftReports404Schema,
  PostApiProjectsProjectIdShiftReports422Schema,
} from '../types/postApiProjectsProjectIdShiftReportsSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate422Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchive401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchive403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchive404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdArchive422Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdArchiveSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators422Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments422Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdDocumentsSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdExportMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExportQueryParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExport400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExport401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExport403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdExport404Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdExportSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdImport422Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdImportSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublishQueryParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublish400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublish401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublish403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdPublish404Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdPublishSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionQueryParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection403Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdResetSectionSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind422Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments422Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestore401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestore403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestore404Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdRestore422Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdRestoreSchema';
import type {
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationResponseSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview400Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview401Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview403Schema,
  PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview404Schema,
} from '../types/postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewSchema';
import type {
  PostApiProjectsProjectIdTeamJoinTokensTokenJoinMutationResponseSchema,
  PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema,
  PostApiProjectsProjectIdTeamJoinTokensTokenJoin401Schema,
  PostApiProjectsProjectIdTeamJoinTokensTokenJoin404Schema,
  PostApiProjectsProjectIdTeamJoinTokensTokenJoin422Schema,
} from '../types/postApiProjectsProjectIdTeamJoinTokensTokenJoinSchema';
import type {
  PostApiProjectsProjectIdTeamsMutationRequestSchema,
  PostApiProjectsProjectIdTeamsMutationResponseSchema,
  PostApiProjectsProjectIdTeamsPathParamsSchema,
  PostApiProjectsProjectIdTeams401Schema,
  PostApiProjectsProjectIdTeams403Schema,
  PostApiProjectsProjectIdTeams404Schema,
  PostApiProjectsProjectIdTeams422Schema,
} from '../types/postApiProjectsProjectIdTeamsSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdJoinToken401Schema,
  PostApiProjectsProjectIdTeamsTeamIdJoinToken403Schema,
  PostApiProjectsProjectIdTeamsTeamIdJoinToken404Schema,
  PostApiProjectsProjectIdTeamsTeamIdJoinToken422Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdJoinTokenSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembers401Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembers403Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembers404Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembers422Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdMembersSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive401Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive403Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive404Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive422Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail401Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail403Schema,
  PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail404Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites401Schema,
  PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites403Schema,
  PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites404Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdResendMembersInvitesSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesKind422Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdResourcesKindSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable401Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable403Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable404Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable401Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable403Schema,
  PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable404Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal401Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal403Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal404Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal422Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm401Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm403Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm404Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm422Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmSchema';
import type {
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationResponseSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema,
  PostApiProjectsProjectIdTeamsTeamIdSubscription401Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscription403Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscription404Schema,
  PostApiProjectsProjectIdTeamsTeamIdSubscription422Schema,
} from '../types/postApiProjectsProjectIdTeamsTeamIdSubscriptionSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlans400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlans401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlans403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlans404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlans422Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays422Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch404Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities422Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort404Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive422Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose422Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate422Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport404Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport404Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill400Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill422Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish422Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishSchema';
import type {
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationResponseSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore401Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore403Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore404Schema,
  PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore422Schema,
} from '../types/postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreSchema';
import type {
  PostApiProjectsMutationRequestSchema,
  PostApiProjectsMutationResponseSchema,
  PostApiProjects401Schema,
  PostApiProjects403Schema,
} from '../types/postApiProjectsSchema';
import type {
  PostApiProjectsShowcasesMutationRequestSchema,
  PostApiProjectsShowcasesMutationResponseSchema,
  PostApiProjectsShowcases401Schema,
  PostApiProjectsShowcases403Schema,
} from '../types/postApiProjectsShowcasesSchema';
import type {
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationResponseSchema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId400Schema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema,
  PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId422Schema,
} from '../types/putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdSchema';
import { buildFormData } from '../.kubb/config';

function getPostApiChannelsTokenUrl() {
  const res = { method: 'POST', url: `/api/channels/token` as const };
  return res;
}

/**
 * @summary Requests a new Channels token
 * {@link /api/channels/token}
 */
export async function postApiChannelsToken(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiChannelsTokenMutationResponseSchema,
    ResponseErrorConfig<PostApiChannelsToken401Schema | PostApiChannelsToken422Schema | PostApiChannelsToken503Schema>,
    unknown
  >({
    method: 'POST',
    url: getPostApiChannelsTokenUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdChannelsPersonalUrl(
  project_id: PostApiProjectsProjectIdChannelsPersonalPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/channels/personal` as const,
  };
  return res;
}

/**
 * @summary Create personal channel
 * {@link /api/projects/:project_id/channels/personal}
 */
export async function postApiProjectsProjectIdChannelsPersonal(
  project_id: PostApiProjectsProjectIdChannelsPersonalPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdChannelsPersonalMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsPersonal401Schema
      | PostApiProjectsProjectIdChannelsPersonal403Schema
      | PostApiProjectsProjectIdChannelsPersonal404Schema
      | PostApiProjectsProjectIdChannelsPersonal422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdChannelsPersonalUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdChannelsMessagingUrl(
  project_id: PostApiProjectsProjectIdChannelsMessagingPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/channels/messaging` as const,
  };
  return res;
}

/**
 * @summary Create messaging channel
 * {@link /api/projects/:project_id/channels/messaging}
 */
export async function postApiProjectsProjectIdChannelsMessaging(
  project_id: PostApiProjectsProjectIdChannelsMessagingPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdChannelsMessagingMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsMessaging400Schema
      | PostApiProjectsProjectIdChannelsMessaging401Schema
      | PostApiProjectsProjectIdChannelsMessaging403Schema
      | PostApiProjectsProjectIdChannelsMessaging404Schema
      | PostApiProjectsProjectIdChannelsMessaging422Schema
    >,
    PostApiProjectsProjectIdChannelsMessagingMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdChannelsMessagingUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsUrl(
  project_id: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema['project_id'],
  message_id: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema['message_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/channels/messages/${message_id}/save_attachments` as const,
  };
  return res;
}

/**
 * @summary Save message attachments to project gallery
 * {@link /api/projects/:project_id/channels/messages/:message_id/save_attachments}
 */
export async function postApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments(
  project_id: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema['project_id'],
  message_id: PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsPathParamsSchema['message_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments401Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments403Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments404Schema
      | PostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachments422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdChannelsMessagesMessageIdSaveAttachmentsUrl(project_id, message_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdCommentsUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/comments` as const,
  };
  return res;
}

/**
 * @summary Creates a comment
 * {@link /api/projects/:project_id/issues/:issue_id/comments}
 */
export async function postApiProjectsProjectIdIssuesIssueIdComments(
  project_id: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdCommentsPathParamsSchema['issue_id'],
  data: PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdCommentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdComments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdComments403Schema
      | PostApiProjectsProjectIdIssuesIssueIdComments404Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdCommentsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdCommentsUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdUrl(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema['issue_id'],
  comment_id: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema['comment_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/issues/${issue_id}/comments/${comment_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a comment
 * {@link /api/projects/:project_id/issues/:issue_id/comments/:comment_id}
 */
export async function deleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema['issue_id'],
  comment_id: DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdPathParamsSchema['comment_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentId422Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdIssuesIssueIdCommentsCommentIdUrl(
      project_id,
      issue_id,
      comment_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiConfigEnvironmentUrl() {
  const res = { method: 'GET', url: `/api/config/environment` as const };
  return res;
}

/**
 * @summary Return environment configuration
 * {@link /api/config/environment}
 */
export async function getApiConfigEnvironment(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetApiConfigEnvironmentQueryResponseSchema, ResponseErrorConfig<Error>, unknown>({
    method: 'GET',
    url: getGetApiConfigEnvironmentUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiConstructionRolesUrl() {
  const res = { method: 'GET', url: `/api/construction_roles` as const };
  return res;
}

/**
 * @summary Retrieves construction roles
 * {@link /api/construction_roles}
 */
export async function getApiConstructionRoles(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiConstructionRolesQueryResponseSchema,
    ResponseErrorConfig<GetApiConstructionRoles401Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiConstructionRolesUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdContractsContractIdFilesUrl(
  project_id: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema['project_id'],
  contract_id: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema['contract_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/contracts/${contract_id}/files` as const,
  };
  return res;
}

/**
 * @summary Retrieves contract files
 * {@link /api/projects/:project_id/contracts/:contract_id/files}
 */
export async function getApiProjectsProjectIdContractsContractIdFiles(
  project_id: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema['project_id'],
  contract_id: GetApiProjectsProjectIdContractsContractIdFilesPathParamsSchema['contract_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdContractsContractIdFilesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractIdFiles401Schema
      | GetApiProjectsProjectIdContractsContractIdFiles403Schema
      | GetApiProjectsProjectIdContractsContractIdFiles404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdContractsContractIdFilesUrl(project_id, contract_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdContractsContractIdFilesUrl(
  project_id: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema['project_id'],
  contract_id: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema['contract_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/contracts/${contract_id}/files` as const,
  };
  return res;
}

/**
 * @summary Creates a contract file
 * {@link /api/projects/:project_id/contracts/:contract_id/files}
 */
export async function postApiProjectsProjectIdContractsContractIdFiles(
  project_id: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema['project_id'],
  contract_id: PostApiProjectsProjectIdContractsContractIdFilesPathParamsSchema['contract_id'],
  data: PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdContractsContractIdFilesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdContractsContractIdFiles400Schema
      | PostApiProjectsProjectIdContractsContractIdFiles401Schema
      | PostApiProjectsProjectIdContractsContractIdFiles403Schema
      | PostApiProjectsProjectIdContractsContractIdFiles404Schema
      | PostApiProjectsProjectIdContractsContractIdFiles422Schema
    >,
    PostApiProjectsProjectIdContractsContractIdFilesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdContractsContractIdFilesUrl(project_id, contract_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdContractsContractIdFilesIdUrl(
  project_id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['project_id'],
  contract_id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['contract_id'],
  id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/contracts/${contract_id}/files/${id}` as const,
  };
  return res;
}

/**
 * @summary Updates a contract file
 * {@link /api/projects/:project_id/contracts/:contract_id/files/:id}
 */
export async function patchApiProjectsProjectIdContractsContractIdFilesId(
  project_id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['project_id'],
  contract_id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['contract_id'],
  id: PatchApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['id'],
  data?: PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdContractsContractIdFilesId401Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId403Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId404Schema
      | PatchApiProjectsProjectIdContractsContractIdFilesId422Schema
    >,
    PatchApiProjectsProjectIdContractsContractIdFilesIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdContractsContractIdFilesIdUrl(project_id, contract_id, id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdContractsContractIdFilesIdUrl(
  project_id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['project_id'],
  contract_id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['contract_id'],
  id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/contracts/${contract_id}/files/${id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a contract file
 * {@link /api/projects/:project_id/contracts/:contract_id/files/:id}
 */
export async function deleteApiProjectsProjectIdContractsContractIdFilesId(
  project_id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['project_id'],
  contract_id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['contract_id'],
  id: DeleteApiProjectsProjectIdContractsContractIdFilesIdPathParamsSchema['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdContractsContractIdFilesIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdContractsContractIdFilesId401Schema
      | DeleteApiProjectsProjectIdContractsContractIdFilesId403Schema
      | DeleteApiProjectsProjectIdContractsContractIdFilesId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdContractsContractIdFilesIdUrl(project_id, contract_id, id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdContractsUrl(
  project_id: GetApiProjectsProjectIdContractsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/contracts` as const,
  };
  return res;
}

/**
 * @summary Retrieves contracts
 * {@link /api/projects/:project_id/contracts}
 */
export async function getApiProjectsProjectIdContracts(
  project_id: GetApiProjectsProjectIdContractsPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdContractsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContracts401Schema
      | GetApiProjectsProjectIdContracts403Schema
      | GetApiProjectsProjectIdContracts404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdContractsUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdContractsUrl(
  project_id: PostApiProjectsProjectIdContractsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/contracts` as const,
  };
  return res;
}

/**
 * @summary Creates a contract
 * {@link /api/projects/:project_id/contracts}
 */
export async function postApiProjectsProjectIdContracts(
  project_id: PostApiProjectsProjectIdContractsPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdContractsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdContractsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdContractsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdContracts401Schema
      | PostApiProjectsProjectIdContracts403Schema
      | PostApiProjectsProjectIdContracts422Schema
    >,
    PostApiProjectsProjectIdContractsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdContractsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdContractsContractIdUrl(
  project_id: GetApiProjectsProjectIdContractsContractIdPathParamsSchema['project_id'],
  contract_id: GetApiProjectsProjectIdContractsContractIdPathParamsSchema['contract_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/contracts/${contract_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a contract
 * {@link /api/projects/:project_id/contracts/:contract_id}
 */
export async function getApiProjectsProjectIdContractsContractId(
  project_id: GetApiProjectsProjectIdContractsContractIdPathParamsSchema['project_id'],
  contract_id: GetApiProjectsProjectIdContractsContractIdPathParamsSchema['contract_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdContractsContractIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdContractsContractId401Schema
      | GetApiProjectsProjectIdContractsContractId403Schema
      | GetApiProjectsProjectIdContractsContractId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdContractsContractIdUrl(project_id, contract_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdContractsContractIdUrl(
  project_id: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema['project_id'],
  contract_id: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema['contract_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/contracts/${contract_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a contract
 * {@link /api/projects/:project_id/contracts/:contract_id}
 */
export async function patchApiProjectsProjectIdContractsContractId(
  project_id: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema['project_id'],
  contract_id: PatchApiProjectsProjectIdContractsContractIdPathParamsSchema['contract_id'],
  data?: PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdContractsContractIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdContractsContractId401Schema
      | PatchApiProjectsProjectIdContractsContractId403Schema
      | PatchApiProjectsProjectIdContractsContractId422Schema
    >,
    PatchApiProjectsProjectIdContractsContractIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdContractsContractIdUrl(project_id, contract_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsUrl(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema['project_id'],
  change_signal_id: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema['change_signal_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/change_signals/${change_signal_id}/contract_change_signals` as const,
  };
  return res;
}

/**
 * @summary Assigns a contract to a change signal
 * {@link /api/projects/:project_id/control_center/change_signals/:change_signal_id/contract_change_signals}
 */
export async function postApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema['project_id'],
  change_signal_id: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsPathParamsSchema['change_signal_id'],
  data: PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignals404Schema
    >,
    PostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterChangeSignalsChangeSignalIdContractChangeSignalsUrl(
      project_id,
      change_signal_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterUrl(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/change_signals/search_filter` as const,
  };
  return res;
}

/**
 * @summary Retrieves the search filter for change signals assigned to the current team member
 * {@link /api/projects/:project_id/control_center/change_signals/search_filter}
 */
export async function getApiProjectsProjectIdControlCenterChangeSignalsSearchFilter(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterChangeSignalsSearchFilterUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterUrl(
  project_id: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema['project_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/control_center/change_signals/search_filter` as const,
  };
  return res;
}

/**
 * @summary Sets the search filter for change signals assigned to the current team member
 * {@link /api/projects/:project_id/control_center/change_signals/search_filter}
 */
export async function patchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter(
  project_id: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterPathParamsSchema['project_id'],
  data?: PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema,
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter401Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter403Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter404Schema
      | PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilter422Schema
    >,
    PatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdControlCenterChangeSignalsSearchFilterUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterChangeSignalsIssuesUrl(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/change_signals/issues` as const,
  };
  return res;
}

/**
 * @summary Retrieves issue change signals
 * {@link /api/projects/:project_id/control_center/change_signals/issues}
 */
export async function getApiProjectsProjectIdControlCenterChangeSignalsIssues(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterChangeSignalsIssuesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsIssues404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterChangeSignalsIssuesUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchUrl(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/change_signals/issues_search` as const,
  };
  return res;
}

/**
 * @summary Performs a issue change signals search
 * {@link /api/projects/:project_id/control_center/change_signals/issues_search}
 */
export async function postApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema,
  params?: PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchQueryParamsSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearch404Schema
    >,
    PostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterChangeSignalsIssuesSearchUrl(project_id).url.toString(),
    params,
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterChangeSignalsDowntimesUrl(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/change_signals/downtimes` as const,
  };
  return res;
}

/**
 * @summary Retrieves downtime change signals
 * {@link /api/projects/:project_id/control_center/change_signals/downtimes}
 */
export async function getApiProjectsProjectIdControlCenterChangeSignalsDowntimes(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterChangeSignalsDowntimesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsDowntimes404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterChangeSignalsDowntimesUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchUrl(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/change_signals/downtimes_search` as const,
  };
  return res;
}

/**
 * @summary Performs a downtime change signals search
 * {@link /api/projects/:project_id/control_center/change_signals/downtimes_search}
 */
export async function postApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema,
  params?: PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchQueryParamsSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearch404Schema
    >,
    PostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterChangeSignalsDowntimesSearchUrl(project_id).url.toString(),
    params,
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsUrl(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/change_signals/progress_logs` as const,
  };
  return res;
}

/**
 * @summary Retrieves progress log change signals
 * {@link /api/projects/:project_id/control_center/change_signals/progress_logs}
 */
export async function getApiProjectsProjectIdControlCenterChangeSignalsProgressLogs(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsProgressLogs404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterChangeSignalsProgressLogsUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchUrl(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/change_signals/progress_logs_search` as const,
  };
  return res;
}

/**
 * @summary Performs a progress log change signals search
 * {@link /api/projects/:project_id/control_center/change_signals/progress_logs_search}
 */
export async function postApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema,
  params?: PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchQueryParamsSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearch404Schema
    >,
    PostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterChangeSignalsProgressLogsSearchUrl(project_id).url.toString(),
    params,
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissUrl(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/change_signals/batch_dismiss` as const,
  };
  return res;
}

/**
 * @summary Dismisses change signals
 * {@link /api/projects/:project_id/control_center/change_signals/batch_dismiss}
 */
export async function postApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss(
  project_id: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema,
  params?: PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissQueryParamsSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss401Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss403Schema
      | PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismiss404Schema
    >,
    PostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterChangeSignalsBatchDismissUrl(project_id).url.toString(),
    params,
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterChangeSignalsCountersUrl(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/change_signals/counters` as const,
  };
  return res;
}

/**
 * @summary Retrieves change signals counters
 * {@link /api/projects/:project_id/control_center/change_signals/counters}
 */
export async function getApiProjectsProjectIdControlCenterChangeSignalsCounters(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsCountersPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterChangeSignalsCountersQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsCounters403Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterChangeSignalsCountersUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterChangeSignalsIdUrl(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema['project_id'],
  id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema['id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/change_signals/${id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a change signal
 * {@link /api/projects/:project_id/control_center/change_signals/:id}
 */
export async function getApiProjectsProjectIdControlCenterChangeSignalsId(
  project_id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema['project_id'],
  id: GetApiProjectsProjectIdControlCenterChangeSignalsIdPathParamsSchema['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterChangeSignalsIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterChangeSignalsId401Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId403Schema
      | GetApiProjectsProjectIdControlCenterChangeSignalsId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterChangeSignalsIdUrl(project_id, id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdUrl(
  project_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema['project_id'],
  potential_change_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema['potential_change_id'],
  document_reference_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema['document_reference_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/document_references/${document_reference_id}` as const,
  };
  return res;
}

/**
 * @summary Removes a document from a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/document_references/:document_reference_id}
 */
export async function deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId(
  project_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema['project_id'],
  potential_change_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema['potential_change_id'],
  document_reference_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdPathParamsSchema['document_reference_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentReferencesDocumentReferenceIdUrl(
      project_id,
      potential_change_id,
      document_reference_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsUrl(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Retrieves potential change documents, including documents attached to its linked signalables
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/documents}
 */
export async function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema['potential_change_id'],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsUrl(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Adds a document to a potential change (from an upload or an existing document)
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/documents}
 */
export async function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsPathParamsSchema['potential_change_id'],
  data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocuments422Schema
    >,
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdDocumentsUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedUrl(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/feed` as const,
  };
  return res;
}

/**
 * @summary Retrieves the feed of the PotentialChange events
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/feed}
 */
export async function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedPathParamsSchema['potential_change_id'],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeed404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdFeedUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportUrl(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/export` as const,
  };
  return res;
}

/**
 * @summary Creates a potential change export
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/export}
 */
export async function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportPathParamsSchema['potential_change_id'],
  data?: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExport404Schema
    >,
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdExportUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteUrl(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/change_signal_links/batch_delete` as const,
  };
  return res;
}

/**
 * @summary Delete potential change change signal links
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/change_signal_links/batch_delete}
 */
export async function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeletePathParamsSchema['potential_change_id'],
  data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDelete403Schema
    >,
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchDeleteUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateUrl(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/change_signal_links/batch_create` as const,
  };
  return res;
}

/**
 * @summary Creates potential change change signal links
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/change_signal_links/batch_create}
 */
export async function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreatePathParamsSchema['potential_change_id'],
  data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreate403Schema
    >,
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdChangeSignalLinksBatchCreateUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeUrl(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/narrative` as const,
  };
  return res;
}

/**
 * @summary Retrieves potential change narrative
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/narrative}
 */
export async function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema['potential_change_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeUrl(
  project_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema['project_id'],
  potential_change_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/narrative` as const,
  };
  return res;
}

/**
 * @summary Updates potential change narrative
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/narrative}
 */
export async function patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative(
  project_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema['project_id'],
  potential_change_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativePathParamsSchema['potential_change_id'],
  data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema,
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative400Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrative404Schema
    >,
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdNarrativeUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterPotentialChangesUrl(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/potential_changes` as const,
  };
  return res;
}

/**
 * @summary Retrieves potential changes
 * {@link /api/projects/:project_id/control_center/potential_changes}
 */
export async function getApiProjectsProjectIdControlCenterPotentialChanges(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterPotentialChangesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChanges401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChanges404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterPotentialChangesUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterPotentialChangesUrl(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/potential_changes` as const,
  };
  return res;
}

/**
 * @summary Creates a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes}
 */
export async function postApiProjectsProjectIdControlCenterPotentialChanges(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema,
  params?: PostApiProjectsProjectIdControlCenterPotentialChangesQueryParamsSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterPotentialChangesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChanges401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChanges422Schema
    >,
    PostApiProjectsProjectIdControlCenterPotentialChangesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterPotentialChangesUrl(project_id).url.toString(),
    params,
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdUrl(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id}
 */
export async function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema['potential_change_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdUrl(
  project_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema['project_id'],
  potential_change_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id}
 */
export async function patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId(
  project_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema['project_id'],
  potential_change_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdPathParamsSchema['potential_change_id'],
  data?: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema,
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId404Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeId422Schema
    >,
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveUrl(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/archive` as const,
  };
  return res;
}

/**
 * @summary Archives a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/archive}
 */
export async function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchivePathParamsSchema['potential_change_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive404Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchive422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdArchiveUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewUrl(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/schedule_view` as const,
  };
  return res;
}

/**
 * @summary Retrieves the schedule view for a potential change
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view}
 */
export async function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewPathParamsSchema['potential_change_id'],
  params: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleView404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileUrl(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/schedule_view/reconcile` as const,
  };
  return res;
}

/**
 * @summary Reconciles the schedule view with the change linked signals
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/reconcile}
 */
export async function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcilePathParamsSchema['potential_change_id'],
  params: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcile404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewReconcileUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateUrl(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema['potential_change_id'],
  row_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema['row_id'],
  date: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema['date']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/schedule_view/rows/${row_id}/days/${date}` as const,
  };
  return res;
}

/**
 * @summary Retrieves day details for a schedule view row
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/days/:date}
 */
export async function getApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate(
  project_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema['project_id'],
  potential_change_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema['potential_change_id'],
  row_id: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema['row_id'],
  date: GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDatePathParamsSchema['date'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate400Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate401Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate403Schema
      | GetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDate404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdDaysDateUrl(
      project_id,
      potential_change_id,
      row_id,
      date
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesUrl(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema['potential_change_id'],
  row_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema['row_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/schedule_view/rows/${row_id}/entries` as const,
  };
  return res;
}

/**
 * @summary Adds an entry to a schedule view row
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/entries}
 */
export async function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema['potential_change_id'],
  row_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesPathParamsSchema['row_id'],
  data: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries400Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntries404Schema
    >,
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesUrl(
      project_id,
      potential_change_id,
      row_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdUrl(
  project_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema['project_id'],
  potential_change_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema['potential_change_id'],
  row_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema['row_id'],
  change_signal_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema['change_signal_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/schedule_view/rows/${row_id}/entries/${change_signal_id}` as const,
  };
  return res;
}

/**
 * @summary Removes an entry from a schedule view row
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:row_id/entries/:change_signal_id}
 */
export async function deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId(
  project_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema['project_id'],
  potential_change_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema['potential_change_id'],
  row_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema['row_id'],
  change_signal_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdPathParamsSchema['change_signal_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsRowIdEntriesChangeSignalIdUrl(
      project_id,
      potential_change_id,
      row_id,
      change_signal_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsUrl(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema['potential_change_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/schedule_view/rows` as const,
  };
  return res;
}

/**
 * @summary Adds an empty row to the schedule view
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows}
 */
export async function postApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows(
  project_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema['project_id'],
  potential_change_id: PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsPathParamsSchema['potential_change_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows401Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows403Schema
      | PostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRows404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsUrl(
      project_id,
      potential_change_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdUrl(
  project_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['project_id'],
  potential_change_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['potential_change_id'],
  id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/schedule_view/rows/${id}` as const,
  };
  return res;
}

/**
 * @summary Updates a schedule view row
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:id}
 */
export async function patchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId(
  project_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['project_id'],
  potential_change_id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['potential_change_id'],
  id: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['id'],
  data: PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema,
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId400Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
      | PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId422Schema
    >,
    PatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdUrl(
      project_id,
      potential_change_id,
      id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdUrl(
  project_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['project_id'],
  potential_change_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['potential_change_id'],
  id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/control_center/potential_changes/${potential_change_id}/schedule_view/rows/${id}` as const,
  };
  return res;
}

/**
 * @summary Removes a row from the schedule view
 * {@link /api/projects/:project_id/control_center/potential_changes/:potential_change_id/schedule_view/rows/:id}
 */
export async function deleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId(
  project_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['project_id'],
  potential_change_id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['potential_change_id'],
  id: DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdPathParamsSchema['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId401Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId403Schema
      | DeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdControlCenterPotentialChangesPotentialChangeIdScheduleViewRowsIdUrl(
      project_id,
      potential_change_id,
      id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdControlCenterTeamPersonalizationUrl(
  project_id: GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/control_center/team_personalization` as const,
  };
  return res;
}

/**
 * @summary Retrieves team personalization for the control center
 * {@link /api/projects/:project_id/control_center/team_personalization}
 */
export async function getApiProjectsProjectIdControlCenterTeamPersonalization(
  project_id: GetApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdControlCenterTeamPersonalizationQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdControlCenterTeamPersonalization401Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization403Schema
      | GetApiProjectsProjectIdControlCenterTeamPersonalization404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdControlCenterTeamPersonalizationUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdControlCenterTeamPersonalizationUrl(
  project_id: PatchApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema['project_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/control_center/team_personalization` as const,
  };
  return res;
}

/**
 * @summary Updates the control center team personalization
 * {@link /api/projects/:project_id/control_center/team_personalization}
 */
export async function patchApiProjectsProjectIdControlCenterTeamPersonalization(
  project_id: PatchApiProjectsProjectIdControlCenterTeamPersonalizationPathParamsSchema['project_id'],
  data?: PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization401Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization403Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization404Schema
      | PatchApiProjectsProjectIdControlCenterTeamPersonalization422Schema
    >,
    PatchApiProjectsProjectIdControlCenterTeamPersonalizationMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdControlCenterTeamPersonalizationUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdCustomFieldsUrl(
  project_id: GetApiProjectsProjectIdCustomFieldsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/custom_fields` as const,
  };
  return res;
}

/**
 * @summary Retrieves project custom fields
 * {@link /api/projects/:project_id/custom_fields}
 */
export async function getApiProjectsProjectIdCustomFields(
  project_id: GetApiProjectsProjectIdCustomFieldsPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdCustomFieldsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdCustomFields401Schema
      | GetApiProjectsProjectIdCustomFields403Schema
      | GetApiProjectsProjectIdCustomFields404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdCustomFieldsUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdCustomFieldsUrl(
  project_id: PostApiProjectsProjectIdCustomFieldsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/custom_fields` as const,
  };
  return res;
}

/**
 * @summary Creates a custom field
 * {@link /api/projects/:project_id/custom_fields}
 */
export async function postApiProjectsProjectIdCustomFields(
  project_id: PostApiProjectsProjectIdCustomFieldsPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdCustomFieldsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdCustomFieldsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdCustomFieldsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdCustomFields401Schema
      | PostApiProjectsProjectIdCustomFields403Schema
      | PostApiProjectsProjectIdCustomFields404Schema
      | PostApiProjectsProjectIdCustomFields422Schema
    >,
    PostApiProjectsProjectIdCustomFieldsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdCustomFieldsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdCustomFieldsCustomFieldIdUrl(
  project_id: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema['project_id'],
  custom_field_id: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema['custom_field_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/custom_fields/${custom_field_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a custom field
 * {@link /api/projects/:project_id/custom_fields/:custom_field_id}
 */
export async function patchApiProjectsProjectIdCustomFieldsCustomFieldId(
  project_id: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema['project_id'],
  custom_field_id: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema['custom_field_id'],
  data: PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
      | PatchApiProjectsProjectIdCustomFieldsCustomFieldId422Schema
    >,
    PatchApiProjectsProjectIdCustomFieldsCustomFieldIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdCustomFieldsCustomFieldIdUrl(project_id, custom_field_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdCustomFieldsCustomFieldIdUrl(
  project_id: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema['project_id'],
  custom_field_id: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema['custom_field_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/custom_fields/${custom_field_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a custom field
 * {@link /api/projects/:project_id/custom_fields/:custom_field_id}
 */
export async function deleteApiProjectsProjectIdCustomFieldsCustomFieldId(
  project_id: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema['project_id'],
  custom_field_id: DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdPathParamsSchema['custom_field_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdCustomFieldsCustomFieldIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId401Schema
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId403Schema
      | DeleteApiProjectsProjectIdCustomFieldsCustomFieldId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdCustomFieldsCustomFieldIdUrl(project_id, custom_field_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdIssuesIssueIdCustomFieldsUrl(
  project_id: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema['project_id'],
  issue_id: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/issues/${issue_id}/custom_fields` as const,
  };
  return res;
}

/**
 * @summary Updates issue custom fields
 * {@link /api/projects/:project_id/issues/:issue_id/custom_fields}
 */
export async function patchApiProjectsProjectIdIssuesIssueIdCustomFields(
  project_id: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema['project_id'],
  issue_id: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsPathParamsSchema['issue_id'],
  data?: PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields401Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields403Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields404Schema
      | PatchApiProjectsProjectIdIssuesIssueIdCustomFields422Schema
    >,
    PatchApiProjectsProjectIdIssuesIssueIdCustomFieldsMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdIssuesIssueIdCustomFieldsUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDashboardsUrl(
  project_id: GetApiProjectsProjectIdDashboardsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/dashboards` as const,
  };
  return res;
}

/**
 * @summary Retrieve dashboards
 * {@link /api/projects/:project_id/dashboards}
 */
export async function getApiProjectsProjectIdDashboards(
  project_id: GetApiProjectsProjectIdDashboardsPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDashboardsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboards401Schema
      | GetApiProjectsProjectIdDashboards403Schema
      | GetApiProjectsProjectIdDashboards404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDashboardsUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesUrl(
  project_id: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/dashboards/data_health_records/issues` as const,
  };
  return res;
}

/**
 * @summary Retrieves data health issues
 * {@link /api/projects/:project_id/dashboards/data_health_records/issues}
 */
export async function getApiProjectsProjectIdDashboardsDataHealthRecordsIssues(
  project_id: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsIssues404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDashboardsDataHealthRecordsIssuesUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsUrl(
  project_id: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/dashboards/data_health_records/shift_reports` as const,
  };
  return res;
}

/**
 * @summary Retrieves data health shift reports
 * {@link /api/projects/:project_id/dashboards/data_health_records/shift_reports}
 */
export async function getApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports(
  project_id: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReports404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDashboardsDataHealthRecordsShiftReportsUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeUrl(
  project_id: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema['project_id'],
  record_type: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema['record_type']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/dashboards/data_health_scores/${record_type}` as const,
  };
  return res;
}

/**
 * @summary Retrieves data health scores
 * {@link /api/projects/:project_id/dashboards/data_health_scores/:record_type}
 */
export async function getApiProjectsProjectIdDashboardsDataHealthScoresRecordType(
  project_id: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema['project_id'],
  record_type: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypePathParamsSchema['record_type'],
  params?: GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType401Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType403Schema
      | GetApiProjectsProjectIdDashboardsDataHealthScoresRecordType404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDashboardsDataHealthScoresRecordTypeUrl(project_id, record_type).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDashboardsDashboardIdEmbeddingUrl(
  project_id: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema['project_id'],
  dashboard_id: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema['dashboard_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/dashboards/${dashboard_id}/embedding` as const,
  };
  return res;
}

/**
 * @summary Retrieve embedding information
 * {@link /api/projects/:project_id/dashboards/:dashboard_id/embedding}
 */
export async function getApiProjectsProjectIdDashboardsDashboardIdEmbedding(
  project_id: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema['project_id'],
  dashboard_id: GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingPathParamsSchema['dashboard_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDashboardsDashboardIdEmbeddingQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding401Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding403Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding404Schema
      | GetApiProjectsProjectIdDashboardsDashboardIdEmbedding503Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDashboardsDashboardIdEmbeddingUrl(project_id, dashboard_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesUrl(
  project_id: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/dashboards/shift_activities/gantt/activities` as const,
  };
  return res;
}

/**
 * @summary Retrieves shift activities for Gantt view
 * {@link /api/projects/:project_id/dashboards/shift_activities/gantt/activities}
 */
export async function getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities(
  project_id: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivities404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateUrl(
  project_id: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema['project_id'],
  activity_id: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema['activity_id'],
  date: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema['date']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/dashboards/shift_activities/gantt/activities/${activity_id}/days/${date}` as const,
  };
  return res;
}

/**
 * @summary Retrieves Gantt dashboard day details for a shift activity
 * {@link /api/projects/:project_id/dashboards/shift_activities/gantt/activities/:activity_id/days/:date}
 */
export async function getApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate(
  project_id: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema['project_id'],
  activity_id: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema['activity_id'],
  date: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDatePathParamsSchema['date'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDate404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDashboardsShiftActivitiesGanttActivitiesActivityIdDaysDateUrl(
      project_id,
      activity_id,
      date
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineUrl(
  project_id: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/dashboards/shift_activities/gantt/timeline` as const,
  };
  return res;
}

/**
 * @summary Retrieves Gantt dashboard timeline for shift activities
 * {@link /api/projects/:project_id/dashboards/shift_activities/gantt/timeline}
 */
export async function getApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline(
  project_id: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelinePathParamsSchema['project_id'],
  params: GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline400Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline401Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline403Schema
      | GetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimeline404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDashboardsShiftActivitiesGanttTimelineUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiDirectUploadsTypeUrl(type: PostApiDirectUploadsTypePathParamsSchema['type']) {
  const res = { method: 'POST', url: `/api/direct_uploads/${type}` as const };
  return res;
}

/**
 * @summary Creates a direct upload
 * {@link /api/direct_uploads/:type}
 */
export async function postApiDirectUploadsType(
  type: PostApiDirectUploadsTypePathParamsSchema['type'],
  data: PostApiDirectUploadsTypeMutationRequestSchema,
  config: Partial<RequestConfig<PostApiDirectUploadsTypeMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiDirectUploadsTypeMutationResponseSchema,
    ResponseErrorConfig<
      PostApiDirectUploadsType400Schema | PostApiDirectUploadsType401Schema | PostApiDirectUploadsType404Schema
    >,
    PostApiDirectUploadsTypeMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiDirectUploadsTypeUrl(type).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDisciplinesUrl(
  project_id: GetApiProjectsProjectIdDisciplinesPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/disciplines` as const,
  };
  return res;
}

/**
 * @summary Retrieves disciplines
 * {@link /api/projects/:project_id/disciplines}
 */
export async function getApiProjectsProjectIdDisciplines(
  project_id: GetApiProjectsProjectIdDisciplinesPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdDisciplinesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDisciplinesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplines401Schema
      | GetApiProjectsProjectIdDisciplines403Schema
      | GetApiProjectsProjectIdDisciplines404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDisciplinesUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdDisciplinesUrl(
  project_id: PostApiProjectsProjectIdDisciplinesPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/disciplines` as const,
  };
  return res;
}

/**
 * @summary Creates a discipline
 * {@link /api/projects/:project_id/disciplines}
 */
export async function postApiProjectsProjectIdDisciplines(
  project_id: PostApiProjectsProjectIdDisciplinesPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdDisciplinesMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdDisciplinesMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdDisciplinesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplines401Schema
      | PostApiProjectsProjectIdDisciplines403Schema
      | PostApiProjectsProjectIdDisciplines404Schema
      | PostApiProjectsProjectIdDisciplines422Schema
    >,
    PostApiProjectsProjectIdDisciplinesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdDisciplinesUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDisciplinesDisciplineIdUrl(
  project_id: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['project_id'],
  discipline_id: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['discipline_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/disciplines/${discipline_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a discipline
 * {@link /api/projects/:project_id/disciplines/:discipline_id}
 */
export async function getApiProjectsProjectIdDisciplinesDisciplineId(
  project_id: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['project_id'],
  discipline_id: GetApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['discipline_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDisciplinesDisciplineIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | GetApiProjectsProjectIdDisciplinesDisciplineId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDisciplinesDisciplineIdUrl(project_id, discipline_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdDisciplinesDisciplineIdUrl(
  project_id: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['project_id'],
  discipline_id: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['discipline_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/disciplines/${discipline_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a discipline
 * {@link /api/projects/:project_id/disciplines/:discipline_id}
 */
export async function patchApiProjectsProjectIdDisciplinesDisciplineId(
  project_id: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['project_id'],
  discipline_id: PatchApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['discipline_id'],
  data?: PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId404Schema
      | PatchApiProjectsProjectIdDisciplinesDisciplineId422Schema
    >,
    PatchApiProjectsProjectIdDisciplinesDisciplineIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdDisciplinesDisciplineIdUrl(project_id, discipline_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdDisciplinesDisciplineIdUrl(
  project_id: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['project_id'],
  discipline_id: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['discipline_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/disciplines/${discipline_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a discipline
 * {@link /api/projects/:project_id/disciplines/:discipline_id}
 */
export async function deleteApiProjectsProjectIdDisciplinesDisciplineId(
  project_id: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['project_id'],
  discipline_id: DeleteApiProjectsProjectIdDisciplinesDisciplineIdPathParamsSchema['discipline_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdDisciplinesDisciplineIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId401Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId403Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId404Schema
      | DeleteApiProjectsProjectIdDisciplinesDisciplineId422Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdDisciplinesDisciplineIdUrl(project_id, discipline_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdDisciplinesSortUrl(
  project_id: PostApiProjectsProjectIdDisciplinesSortPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/disciplines/sort` as const,
  };
  return res;
}

/**
 * @summary Sorts disciplines
 * {@link /api/projects/:project_id/disciplines/sort}
 */
export async function postApiProjectsProjectIdDisciplinesSort(
  project_id: PostApiProjectsProjectIdDisciplinesSortPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdDisciplinesSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDisciplinesSort401Schema
      | PostApiProjectsProjectIdDisciplinesSort403Schema
      | PostApiProjectsProjectIdDisciplinesSort404Schema
    >,
    PostApiProjectsProjectIdDisciplinesSortMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdDisciplinesSortUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDocumentsDocumentIdReferencesUrl(
  project_id: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema['project_id'],
  document_id: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema['document_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/documents/${document_id}/references` as const,
  };
  return res;
}

/**
 * @summary Retrieves document references
 * {@link /api/projects/:project_id/documents/:document_id/references}
 */
export async function getApiProjectsProjectIdDocumentsDocumentIdReferences(
  project_id: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema['project_id'],
  document_id: GetApiProjectsProjectIdDocumentsDocumentIdReferencesPathParamsSchema['document_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDocumentsDocumentIdReferencesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences401Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences403Schema
      | GetApiProjectsProjectIdDocumentsDocumentIdReferences404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDocumentsDocumentIdReferencesUrl(project_id, document_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDocumentsUrl(
  project_id: GetApiProjectsProjectIdDocumentsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Retrieves documents
 * {@link /api/projects/:project_id/documents}
 */
export async function getApiProjectsProjectIdDocuments(
  project_id: GetApiProjectsProjectIdDocumentsPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocuments400Schema
      | GetApiProjectsProjectIdDocuments401Schema
      | GetApiProjectsProjectIdDocuments403Schema
      | GetApiProjectsProjectIdDocuments404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDocumentsUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdDocumentsUrl(
  project_id: PostApiProjectsProjectIdDocumentsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Creates a document
 * {@link /api/projects/:project_id/documents}
 */
export async function postApiProjectsProjectIdDocuments(
  project_id: PostApiProjectsProjectIdDocumentsPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdDocumentsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdDocumentsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdDocuments400Schema
      | PostApiProjectsProjectIdDocuments401Schema
      | PostApiProjectsProjectIdDocuments403Schema
      | PostApiProjectsProjectIdDocuments404Schema
      | PostApiProjectsProjectIdDocuments422Schema
    >,
    PostApiProjectsProjectIdDocumentsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdDocumentsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDocumentsImageUrlsUrl(
  project_id: GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/documents/image_urls` as const,
  };
  return res;
}

/**
 * @summary Retrieves documents image URLs
 * {@link /api/projects/:project_id/documents/image_urls}
 */
export async function getApiProjectsProjectIdDocumentsImageUrls(
  project_id: GetApiProjectsProjectIdDocumentsImageUrlsPathParamsSchema['project_id'],
  params: GetApiProjectsProjectIdDocumentsImageUrlsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDocumentsImageUrlsQueryResponseSchema,
    ResponseErrorConfig<
      GetApiProjectsProjectIdDocumentsImageUrls401Schema | GetApiProjectsProjectIdDocumentsImageUrls403Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDocumentsImageUrlsUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdDocumentsDocumentIdUrl(
  project_id: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['project_id'],
  document_id: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['document_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/documents/${document_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a document
 * {@link /api/projects/:project_id/documents/:document_id}
 */
export async function getApiProjectsProjectIdDocumentsDocumentId(
  project_id: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['project_id'],
  document_id: GetApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['document_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdDocumentsDocumentIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdDocumentsDocumentId401Schema
      | GetApiProjectsProjectIdDocumentsDocumentId403Schema
      | GetApiProjectsProjectIdDocumentsDocumentId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdDocumentsDocumentIdUrl(project_id, document_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdDocumentsDocumentIdUrl(
  project_id: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['project_id'],
  document_id: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['document_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/documents/${document_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a document
 * {@link /api/projects/:project_id/documents/:document_id}
 */
export async function patchApiProjectsProjectIdDocumentsDocumentId(
  project_id: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['project_id'],
  document_id: PatchApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['document_id'],
  data?: PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdDocumentsDocumentId401Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId403Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId404Schema
      | PatchApiProjectsProjectIdDocumentsDocumentId422Schema
    >,
    PatchApiProjectsProjectIdDocumentsDocumentIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdDocumentsDocumentIdUrl(project_id, document_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdDocumentsDocumentIdUrl(
  project_id: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['project_id'],
  document_id: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['document_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/documents/${document_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a document
 * {@link /api/projects/:project_id/documents/:document_id}
 */
export async function deleteApiProjectsProjectIdDocumentsDocumentId(
  project_id: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['project_id'],
  document_id: DeleteApiProjectsProjectIdDocumentsDocumentIdPathParamsSchema['document_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdDocumentsDocumentId401Schema
      | DeleteApiProjectsProjectIdDocumentsDocumentId403Schema
      | DeleteApiProjectsProjectIdDocumentsDocumentId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdDocumentsDocumentIdUrl(project_id, document_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdGroupsGroupIdChannelConfigurationUrl(
  project_id: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema['project_id'],
  group_id: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema['group_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/groups/${group_id}/channel_configuration` as const,
  };
  return res;
}

/**
 * @summary Retrieves the group channel configuration
 * {@link /api/projects/:project_id/groups/:group_id/channel_configuration}
 */
export async function getApiProjectsProjectIdGroupsGroupIdChannelConfiguration(
  project_id: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema['project_id'],
  group_id: GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema['group_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdGroupsGroupIdChannelConfigurationQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdGroupsGroupIdChannelConfigurationUrl(project_id, group_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationUrl(
  project_id: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema['project_id'],
  group_id: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema['group_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/groups/${group_id}/channel_configuration` as const,
  };
  return res;
}

/**
 * @summary Updates the group channel configuration
 * {@link /api/projects/:project_id/groups/:group_id/channel_configuration}
 */
export async function patchApiProjectsProjectIdGroupsGroupIdChannelConfiguration(
  project_id: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema['project_id'],
  group_id: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationPathParamsSchema['group_id'],
  data?: PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration401Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration403Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration404Schema
      | PatchApiProjectsProjectIdGroupsGroupIdChannelConfiguration422Schema
    >,
    PatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdGroupsGroupIdChannelConfigurationUrl(project_id, group_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdGroupsUrl(
  project_id: PostApiProjectsProjectIdGroupsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/groups` as const,
  };
  return res;
}

/**
 * @description Authenticated user will be added automatically as a group member and admin of the group.
 * @summary Creates a group
 * {@link /api/projects/:project_id/groups}
 */
export async function postApiProjectsProjectIdGroups(
  project_id: PostApiProjectsProjectIdGroupsPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdGroupsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdGroupsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdGroupsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdGroups400Schema
      | PostApiProjectsProjectIdGroups401Schema
      | PostApiProjectsProjectIdGroups403Schema
      | PostApiProjectsProjectIdGroups404Schema
      | PostApiProjectsProjectIdGroups422Schema
    >,
    PostApiProjectsProjectIdGroupsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdGroupsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdGroupsGroupIdUrl(
  project_id: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema['project_id'],
  group_id: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema['group_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/groups/${group_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a group
 * {@link /api/projects/:project_id/groups/:group_id}
 */
export async function getApiProjectsProjectIdGroupsGroupId(
  project_id: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema['project_id'],
  group_id: GetApiProjectsProjectIdGroupsGroupIdPathParamsSchema['group_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdGroupsGroupIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdGroupsGroupId401Schema
      | GetApiProjectsProjectIdGroupsGroupId403Schema
      | GetApiProjectsProjectIdGroupsGroupId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdGroupsGroupIdUrl(project_id, group_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdGroupsGroupIdUrl(
  project_id: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema['project_id'],
  group_id: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema['group_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/groups/${group_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a group
 * {@link /api/projects/:project_id/groups/:group_id}
 */
export async function patchApiProjectsProjectIdGroupsGroupId(
  project_id: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema['project_id'],
  group_id: PatchApiProjectsProjectIdGroupsGroupIdPathParamsSchema['group_id'],
  data?: PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupId400Schema
      | PatchApiProjectsProjectIdGroupsGroupId401Schema
      | PatchApiProjectsProjectIdGroupsGroupId403Schema
      | PatchApiProjectsProjectIdGroupsGroupId404Schema
      | PatchApiProjectsProjectIdGroupsGroupId422Schema
    >,
    PatchApiProjectsProjectIdGroupsGroupIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdGroupsGroupIdUrl(project_id, group_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdGroupsGroupIdUrl(
  project_id: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema['project_id'],
  group_id: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema['group_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/groups/${group_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a group
 * {@link /api/projects/:project_id/groups/:group_id}
 */
export async function deleteApiProjectsProjectIdGroupsGroupId(
  project_id: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema['project_id'],
  group_id: DeleteApiProjectsProjectIdGroupsGroupIdPathParamsSchema['group_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdGroupsGroupIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdGroupsGroupId401Schema
      | DeleteApiProjectsProjectIdGroupsGroupId403Schema
      | DeleteApiProjectsProjectIdGroupsGroupId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdGroupsGroupIdUrl(project_id, group_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdGroupsGroupIdMembersUrl(
  project_id: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema['project_id'],
  group_id: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema['group_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/groups/${group_id}/members` as const,
  };
  return res;
}

/**
 * @summary Updates group members
 * {@link /api/projects/:project_id/groups/:group_id/members}
 */
export async function patchApiProjectsProjectIdGroupsGroupIdMembers(
  project_id: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema['project_id'],
  group_id: PatchApiProjectsProjectIdGroupsGroupIdMembersPathParamsSchema['group_id'],
  data?: PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdGroupsGroupIdMembersMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdGroupsGroupIdMembers401Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers403Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers404Schema
      | PatchApiProjectsProjectIdGroupsGroupIdMembers422Schema
    >,
    PatchApiProjectsProjectIdGroupsGroupIdMembersMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdGroupsGroupIdMembersUrl(project_id, group_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdAssignmentsUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/assignments` as const,
  };
  return res;
}

/**
 * @summary Creates an issue assignment
 * {@link /api/projects/:project_id/issues/:issue_id/assignments}
 */
export async function postApiProjectsProjectIdIssuesIssueIdAssignments(
  project_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsPathParamsSchema['issue_id'],
  data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignments400Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignments404Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdAssignmentsUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema['issue_id'],
  issue_assignment_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema['issue_assignment_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/assignments/${issue_assignment_id}/accept` as const,
  };
  return res;
}

/**
 * @summary Accepts issue assignment
 * {@link /api/projects/:project_id/issues/:issue_id/assignments/:issue_assignment_id/accept}
 */
export async function postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept(
  project_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema['issue_id'],
  issue_assignment_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptPathParamsSchema['issue_assignment_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAccept404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdAcceptUrl(
      project_id,
      issue_id,
      issue_assignment_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema['issue_id'],
  issue_assignment_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema['issue_assignment_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/assignments/${issue_assignment_id}/reject` as const,
  };
  return res;
}

/**
 * @summary Rejects issue assignment
 * {@link /api/projects/:project_id/issues/:issue_id/assignments/:issue_assignment_id/reject}
 */
export async function postApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject(
  project_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema['issue_id'],
  issue_assignment_id: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectPathParamsSchema['issue_assignment_id'],
  data?: PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject401Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject403Schema
      | PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdReject404Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdAssignmentsIssueAssignmentIdRejectUrl(
      project_id,
      issue_id,
      issue_assignment_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdUrl(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema['issue_id'],
  document_reference_id: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema['document_reference_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/issues/${issue_id}/document_references/${document_reference_id}` as const,
  };
  return res;
}

/**
 * @summary Removes a document from an issue
 * {@link /api/projects/:project_id/issues/:issue_id/document_references/:document_reference_id}
 */
export async function deleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema['issue_id'],
  document_reference_id: DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdPathParamsSchema['document_reference_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdIssuesIssueIdDocumentReferencesDocumentReferenceIdUrl(
      project_id,
      issue_id,
      document_reference_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesIssueIdDocumentsUrl(
  project_id: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/${issue_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Retrieves issue documents
 * {@link /api/projects/:project_id/issues/:issue_id/documents}
 */
export async function getApiProjectsProjectIdIssuesIssueIdDocuments(
  project_id: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema['issue_id'],
  params?: GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesIssueIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdDocuments400Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments401Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments403Schema
      | GetApiProjectsProjectIdIssuesIssueIdDocuments404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesIssueIdDocumentsUrl(project_id, issue_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdDocumentsUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Adds a document to an issue (from an upload or an existing document)
 * {@link /api/projects/:project_id/issues/:issue_id/documents}
 */
export async function postApiProjectsProjectIdIssuesIssueIdDocuments(
  project_id: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdDocumentsPathParamsSchema['issue_id'],
  data?: PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdDocuments400Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments401Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments403Schema
      | PostApiProjectsProjectIdIssuesIssueIdDocuments422Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdDocumentsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdDocumentsUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesIssueIdFeedTeamUrl(
  project_id: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema['issue_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/${issue_id}/feed/team` as const,
  };
  return res;
}

/**
 * @summary Retrieves team only issue events
 * {@link /api/projects/:project_id/issues/:issue_id/feed/team}
 */
export async function getApiProjectsProjectIdIssuesIssueIdFeedTeam(
  project_id: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdFeedTeamPathParamsSchema['issue_id'],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesIssueIdFeedTeamQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam403Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedTeam404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesIssueIdFeedTeamUrl(project_id, issue_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesIssueIdFeedPublicUrl(
  project_id: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema['issue_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/${issue_id}/feed/public` as const,
  };
  return res;
}

/**
 * @summary Retrieves public issue events
 * {@link /api/projects/:project_id/issues/:issue_id/feed/public}
 */
export async function getApiProjectsProjectIdIssuesIssueIdFeedPublic(
  project_id: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdFeedPublicPathParamsSchema['issue_id'],
  params?: GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesIssueIdFeedPublicQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic400Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic401Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic403Schema
      | GetApiProjectsProjectIdIssuesIssueIdFeedPublic404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesIssueIdFeedPublicUrl(project_id, issue_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesIssueIdIssueImagesUrl(
  project_id: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema['issue_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/${issue_id}/issue_images` as const,
  };
  return res;
}

/**
 * @description Deprecated: use /api/projects/{project_id}/issues/{issue_id}/documents
 * @summary Retrieves issue images and evidence images
 * {@link /api/projects/:project_id/issues/:issue_id/issue_images}
 * @deprecated
 */
export async function getApiProjectsProjectIdIssuesIssueIdIssueImages(
  project_id: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema['issue_id'],
  params?: GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesIssueIdIssueImagesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
      | GetApiProjectsProjectIdIssuesIssueIdIssueImages404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesIssueIdIssueImagesUrl(project_id, issue_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdIssueImagesUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/issue_images` as const,
  };
  return res;
}

/**
 * @description Deprecated: use /api/projects/{project_id}/issues/{issue_id}/documents
 * @summary Uploads an image (from an upload or an existing document)
 * {@link /api/projects/:project_id/issues/:issue_id/issue_images}
 * @deprecated
 */
export async function postApiProjectsProjectIdIssuesIssueIdIssueImages(
  project_id: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdIssueImagesPathParamsSchema['issue_id'],
  data?: PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages400Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages401Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages403Schema
      | PostApiProjectsProjectIdIssuesIssueIdIssueImages422Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdIssueImagesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdIssueImagesUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdUrl(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['issue_id'],
  issue_image_id: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['issue_image_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/issues/${issue_id}/issue_images/${issue_image_id}` as const,
  };
  return res;
}

/**
 * @description Deprecated: use /api/projects/{project_id}/issues/{issue_id}/document_references/{document_reference_id}
 * @summary Removes an image from an issue
 * {@link /api/projects/:project_id/issues/:issue_id/issue_images/:issue_image_id}
 * @deprecated
 */
export async function deleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['issue_id'],
  issue_image_id: DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['issue_image_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdUrl(
      project_id,
      issue_id,
      issue_image_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdUrl(
  project_id: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['project_id'],
  issue_id: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['issue_id'],
  issue_image_id: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['issue_image_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/issues/${issue_id}/issue_images/${issue_image_id}` as const,
  };
  return res;
}

/**
 * @description Deprecated: use /api/projects/{project_id}/documents/{document_id}
 * @summary Updates an image
 * {@link /api/projects/:project_id/issues/:issue_id/issue_images/:issue_image_id}
 * @deprecated
 */
export async function patchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId(
  project_id: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['project_id'],
  issue_id: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['issue_id'],
  issue_image_id: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdPathParamsSchema['issue_image_id'],
  data?: PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId401Schema
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId403Schema
      | PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageId404Schema
    >,
    PatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdIssuesIssueIdIssueImagesIssueImageIdUrl(
      project_id,
      issue_id,
      issue_image_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesSmartIssuesUrl(
  project_id: PostApiProjectsProjectIdIssuesSmartIssuesPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/smart_issues` as const,
  };
  return res;
}

/**
 * @summary Request smart issue
 * {@link /api/projects/:project_id/issues/smart_issues}
 */
export async function postApiProjectsProjectIdIssuesSmartIssues(
  project_id: PostApiProjectsProjectIdIssuesSmartIssuesPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesSmartIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesSmartIssues401Schema
      | PostApiProjectsProjectIdIssuesSmartIssues403Schema
      | PostApiProjectsProjectIdIssuesSmartIssues404Schema
    >,
    PostApiProjectsProjectIdIssuesSmartIssuesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesSmartIssuesUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdApproveUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/approve` as const,
  };
  return res;
}

/**
 * @summary Approves an issue
 * {@link /api/projects/:project_id/issues/:issue_id/approve}
 */
export async function postApiProjectsProjectIdIssuesIssueIdApprove(
  project_id: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdApprovePathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdApproveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdApprove400Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove401Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove403Schema
      | PostApiProjectsProjectIdIssuesIssueIdApprove404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdApproveUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdCompleteUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/complete` as const,
  };
  return res;
}

/**
 * @summary Updates an issue to completed
 * {@link /api/projects/:project_id/issues/:issue_id/complete}
 */
export async function postApiProjectsProjectIdIssuesIssueIdComplete(
  project_id: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdCompletePathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdCompleteMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdComplete400Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete401Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete403Schema
      | PostApiProjectsProjectIdIssuesIssueIdComplete404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdCompleteUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdRejectUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/reject` as const,
  };
  return res;
}

/**
 * @summary Rejects an issue
 * {@link /api/projects/:project_id/issues/:issue_id/reject}
 */
export async function postApiProjectsProjectIdIssuesIssueIdReject(
  project_id: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdRejectPathParamsSchema['issue_id'],
  data?: PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdReject400Schema
      | PostApiProjectsProjectIdIssuesIssueIdReject401Schema
      | PostApiProjectsProjectIdIssuesIssueIdReject403Schema
      | PostApiProjectsProjectIdIssuesIssueIdReject404Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdRejectMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdRejectUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdReopenUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/reopen` as const,
  };
  return res;
}

/**
 * @summary Reopens an resolved issue
 * {@link /api/projects/:project_id/issues/:issue_id/reopen}
 */
export async function postApiProjectsProjectIdIssuesIssueIdReopen(
  project_id: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdReopenPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdReopenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdReopen400Schema
      | PostApiProjectsProjectIdIssuesIssueIdReopen401Schema
      | PostApiProjectsProjectIdIssuesIssueIdReopen403Schema
      | PostApiProjectsProjectIdIssuesIssueIdReopen404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdReopenUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdStartUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/start` as const,
  };
  return res;
}

/**
 * @summary Updates an issue to in_progress
 * {@link /api/projects/:project_id/issues/:issue_id/start}
 */
export async function postApiProjectsProjectIdIssuesIssueIdStart(
  project_id: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdStartPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdStartMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStart400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart403Schema
      | PostApiProjectsProjectIdIssuesIssueIdStart404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdStartUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdStopUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/stop` as const,
  };
  return res;
}

/**
 * @summary Updates an issue to assigned
 * {@link /api/projects/:project_id/issues/:issue_id/stop}
 */
export async function postApiProjectsProjectIdIssuesIssueIdStop(
  project_id: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdStopPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdStopMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStop400Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop403Schema
      | PostApiProjectsProjectIdIssuesIssueIdStop404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdStopUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdSubmitUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/submit` as const,
  };
  return res;
}

/**
 * @summary Submits a draft issue
 * {@link /api/projects/:project_id/issues/:issue_id/submit}
 */
export async function postApiProjectsProjectIdIssuesIssueIdSubmit(
  project_id: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdSubmitPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdSubmitMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdSubmit401Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit403Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit404Schema
      | PostApiProjectsProjectIdIssuesIssueIdSubmit422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdSubmitUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdStatusStatementsUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/status_statements` as const,
  };
  return res;
}

/**
 * @summary Creates an issue status statement
 * {@link /api/projects/:project_id/issues/:issue_id/status_statements}
 */
export async function postApiProjectsProjectIdIssuesIssueIdStatusStatements(
  project_id: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema['issue_id'],
  data?: PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
      | PostApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdStatusStatementsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdStatusStatementsUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesIssueIdStatusStatementsUrl(
  project_id: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/${issue_id}/status_statements` as const,
  };
  return res;
}

/**
 * @summary Retrieves issue status statements
 * {@link /api/projects/:project_id/issues/:issue_id/status_statements}
 */
export async function getApiProjectsProjectIdIssuesIssueIdStatusStatements(
  project_id: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdStatusStatementsPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesIssueIdStatusStatementsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements401Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements403Schema
      | GetApiProjectsProjectIdIssuesIssueIdStatusStatements404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesIssueIdStatusStatementsUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdUrl(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema['issue_id'],
  status_statement_id: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema['status_statement_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/issues/${issue_id}/status_statements/${status_statement_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes an issue status statement
 * {@link /api/projects/:project_id/issues/:issue_id/status_statements/:status_statement_id}
 */
export async function deleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema['issue_id'],
  status_statement_id: DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdPathParamsSchema['status_statement_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementId422Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdIssuesIssueIdStatusStatementsStatusStatementIdUrl(
      project_id,
      issue_id,
      status_statement_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssueViewsUrl(
  project_id: GetApiProjectsProjectIdIssueViewsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issue_views` as const,
  };
  return res;
}

/**
 * @summary Retrieves issue views
 * {@link /api/projects/:project_id/issue_views}
 */
export async function getApiProjectsProjectIdIssueViews(
  project_id: GetApiProjectsProjectIdIssueViewsPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssueViewsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssueViews401Schema
      | GetApiProjectsProjectIdIssueViews403Schema
      | GetApiProjectsProjectIdIssueViews404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssueViewsUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssueViewsUrl(
  project_id: PostApiProjectsProjectIdIssueViewsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issue_views` as const,
  };
  return res;
}

/**
 * @summary Creates issue view
 * {@link /api/projects/:project_id/issue_views}
 */
export async function postApiProjectsProjectIdIssueViews(
  project_id: PostApiProjectsProjectIdIssueViewsPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdIssueViewsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssueViewsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssueViewsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssueViews401Schema
      | PostApiProjectsProjectIdIssueViews403Schema
      | PostApiProjectsProjectIdIssueViews404Schema
      | PostApiProjectsProjectIdIssueViews422Schema
    >,
    PostApiProjectsProjectIdIssueViewsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssueViewsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdIssueViewsIssueViewIdUrl(
  project_id: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema['project_id'],
  issue_view_id: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema['issue_view_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/issue_views/${issue_view_id}` as const,
  };
  return res;
}

/**
 * @summary Updates issue view
 * {@link /api/projects/:project_id/issue_views/:issue_view_id}
 */
export async function patchApiProjectsProjectIdIssueViewsIssueViewId(
  project_id: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema['project_id'],
  issue_view_id: PatchApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema['issue_view_id'],
  data?: PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssueViewsIssueViewId401Schema
      | PatchApiProjectsProjectIdIssueViewsIssueViewId403Schema
      | PatchApiProjectsProjectIdIssueViewsIssueViewId404Schema
      | PatchApiProjectsProjectIdIssueViewsIssueViewId422Schema
    >,
    PatchApiProjectsProjectIdIssueViewsIssueViewIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdIssueViewsIssueViewIdUrl(project_id, issue_view_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdIssueViewsIssueViewIdUrl(
  project_id: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema['project_id'],
  issue_view_id: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema['issue_view_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/issue_views/${issue_view_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes an issue view
 * {@link /api/projects/:project_id/issue_views/:issue_view_id}
 */
export async function deleteApiProjectsProjectIdIssueViewsIssueViewId(
  project_id: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema['project_id'],
  issue_view_id: DeleteApiProjectsProjectIdIssueViewsIssueViewIdPathParamsSchema['issue_view_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdIssueViewsIssueViewIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId401Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId403Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId404Schema
      | DeleteApiProjectsProjectIdIssueViewsIssueViewId422Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdIssueViewsIssueViewIdUrl(project_id, issue_view_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesIssueIdVisitUrl(
  project_id: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema['issue_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/${issue_id}/visit` as const,
  };
  return res;
}

/**
 * @summary Retrieve issue visit status
 * {@link /api/projects/:project_id/issues/:issue_id/visit}
 */
export async function getApiProjectsProjectIdIssuesIssueIdVisit(
  project_id: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesIssueIdVisitQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | GetApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesIssueIdVisitUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdVisitUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/visit` as const,
  };
  return res;
}

/**
 * @summary Saves issue visit
 * {@link /api/projects/:project_id/issues/:issue_id/visit}
 */
export async function postApiProjectsProjectIdIssuesIssueIdVisit(
  project_id: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdVisitPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdVisitMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdVisit401Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit403Schema
      | PostApiProjectsProjectIdIssuesIssueIdVisit404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdVisitUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsUrl(
  project_id: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/${issue_id}/quality_indicators` as const,
  };
  return res;
}

/**
 * @summary Retrieves all quality indicators for a issue
 * {@link /api/projects/:project_id/issues/:issue_id/quality_indicators}
 */
export async function getApiProjectsProjectIdIssuesIssueIdQualityIndicators(
  project_id: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators401Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators403Schema
      | GetApiProjectsProjectIdIssuesIssueIdQualityIndicators404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesIssueIdQualityIndicatorsUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesUrl(
  project_id: PostApiProjectsProjectIdIssuesPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues` as const,
  };
  return res;
}

/**
 * @summary Creates an issue
 * {@link /api/projects/:project_id/issues}
 */
export async function postApiProjectsProjectIdIssues(
  project_id: PostApiProjectsProjectIdIssuesPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdIssuesMutationRequestSchema,
  headers?: PostApiProjectsProjectIdIssuesHeaderParamsSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssues401Schema
      | PostApiProjectsProjectIdIssues403Schema
      | PostApiProjectsProjectIdIssues404Schema
    >,
    PostApiProjectsProjectIdIssuesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesUrl(project_id: GetApiProjectsProjectIdIssuesPathParamsSchema['project_id']) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues` as const,
  };
  return res;
}

/**
 * @summary Retrieves issues
 * {@link /api/projects/:project_id/issues}
 */
export async function getApiProjectsProjectIdIssues(
  project_id: GetApiProjectsProjectIdIssuesPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdIssuesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssues400Schema
      | GetApiProjectsProjectIdIssues401Schema
      | GetApiProjectsProjectIdIssues403Schema
      | GetApiProjectsProjectIdIssues404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesGroupCountUrl(
  project_id: GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/group_count` as const,
  };
  return res;
}

/**
 * @summary Retrieves issues group count
 * {@link /api/projects/:project_id/issues/group_count}
 */
export async function getApiProjectsProjectIdIssuesGroupCount(
  project_id: GetApiProjectsProjectIdIssuesGroupCountPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdIssuesGroupCountQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesGroupCountQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesGroupCount400Schema
      | GetApiProjectsProjectIdIssuesGroupCount401Schema
      | GetApiProjectsProjectIdIssuesGroupCount403Schema
      | GetApiProjectsProjectIdIssuesGroupCount404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesGroupCountUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesExportUrl(
  project_id: PostApiProjectsProjectIdIssuesExportPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/export` as const,
  };
  return res;
}

/**
 * @description Exporting to PDF is limited to 100 issues
 * @summary Requests issue list export
 * {@link /api/projects/:project_id/issues/export}
 */
export async function postApiProjectsProjectIdIssuesExport(
  project_id: PostApiProjectsProjectIdIssuesExportPathParamsSchema['project_id'],
  params: PostApiProjectsProjectIdIssuesExportQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesExport400Schema
      | PostApiProjectsProjectIdIssuesExport401Schema
      | PostApiProjectsProjectIdIssuesExport403Schema
      | PostApiProjectsProjectIdIssuesExport404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesExportUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesQuickIssuesUrl(
  project_id: PostApiProjectsProjectIdIssuesQuickIssuesPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/quick_issues` as const,
  };
  return res;
}

/**
 * @summary Creates an issue and submits it
 * {@link /api/projects/:project_id/issues/quick_issues}
 */
export async function postApiProjectsProjectIdIssuesQuickIssues(
  project_id: PostApiProjectsProjectIdIssuesQuickIssuesPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema,
  headers?: PostApiProjectsProjectIdIssuesQuickIssuesHeaderParamsSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesQuickIssuesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesQuickIssues400Schema
      | PostApiProjectsProjectIdIssuesQuickIssues401Schema
      | PostApiProjectsProjectIdIssuesQuickIssues403Schema
      | PostApiProjectsProjectIdIssuesQuickIssues404Schema
      | PostApiProjectsProjectIdIssuesQuickIssues422Schema
    >,
    PostApiProjectsProjectIdIssuesQuickIssuesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesQuickIssuesUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesIssueIdUrl(
  project_id: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema['issue_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/${issue_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves an issue
 * {@link /api/projects/:project_id/issues/:issue_id}
 */
export async function getApiProjectsProjectIdIssuesIssueId(
  project_id: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesIssueIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueId401Schema
      | GetApiProjectsProjectIdIssuesIssueId403Schema
      | GetApiProjectsProjectIdIssuesIssueId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesIssueIdUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdIssuesIssueIdUrl(
  project_id: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema['project_id'],
  issue_id: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema['issue_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/issues/${issue_id}` as const,
  };
  return res;
}

/**
 * @summary Updates an issue
 * {@link /api/projects/:project_id/issues/:issue_id}
 */
export async function patchApiProjectsProjectIdIssuesIssueId(
  project_id: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema['project_id'],
  issue_id: PatchApiProjectsProjectIdIssuesIssueIdPathParamsSchema['issue_id'],
  data?: PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdIssuesIssueId401Schema
      | PatchApiProjectsProjectIdIssuesIssueId403Schema
      | PatchApiProjectsProjectIdIssuesIssueId404Schema
      | PatchApiProjectsProjectIdIssuesIssueId422Schema
    >,
    PatchApiProjectsProjectIdIssuesIssueIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdIssuesIssueIdUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdIssuesIssueIdUrl(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema['issue_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/issues/${issue_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes an issue
 * {@link /api/projects/:project_id/issues/:issue_id}
 */
export async function deleteApiProjectsProjectIdIssuesIssueId(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdIssuesIssueIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueId400Schema
      | DeleteApiProjectsProjectIdIssuesIssueId401Schema
      | DeleteApiProjectsProjectIdIssuesIssueId403Schema
      | DeleteApiProjectsProjectIdIssuesIssueId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdIssuesIssueIdUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdArchiveUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/archive` as const,
  };
  return res;
}

/**
 * @summary Archives an issue
 * {@link /api/projects/:project_id/issues/:issue_id/archive}
 */
export async function postApiProjectsProjectIdIssuesIssueIdArchive(
  project_id: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdArchivePathParamsSchema['issue_id'],
  data?: PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdArchive401Schema
      | PostApiProjectsProjectIdIssuesIssueIdArchive403Schema
      | PostApiProjectsProjectIdIssuesIssueIdArchive404Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdArchiveMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdArchiveUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdExportUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/export` as const,
  };
  return res;
}

/**
 * @summary Requests issue export
 * {@link /api/projects/:project_id/issues/:issue_id/export}
 */
export async function postApiProjectsProjectIdIssuesIssueIdExport(
  project_id: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdExportPathParamsSchema['issue_id'],
  data?: PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdExport401Schema
      | PostApiProjectsProjectIdIssuesIssueIdExport403Schema
      | PostApiProjectsProjectIdIssuesIssueIdExport404Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdExportMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdExportUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdRestoreUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/restore` as const,
  };
  return res;
}

/**
 * @summary Restores an archived issue
 * {@link /api/projects/:project_id/issues/:issue_id/restore}
 */
export async function postApiProjectsProjectIdIssuesIssueIdRestore(
  project_id: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdRestorePathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdRestore401Schema
      | PostApiProjectsProjectIdIssuesIssueIdRestore403Schema
      | PostApiProjectsProjectIdIssuesIssueIdRestore404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdRestoreUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdUpdateImpactUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/update_impact` as const,
  };
  return res;
}

/**
 * @summary Updates impact
 * {@link /api/projects/:project_id/issues/:issue_id/update_impact}
 */
export async function postApiProjectsProjectIdIssuesIssueIdUpdateImpact(
  project_id: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactPathParamsSchema['issue_id'],
  data?: PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact401Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact403Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact404Schema
      | PostApiProjectsProjectIdIssuesIssueIdUpdateImpact422Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdUpdateImpactMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdUpdateImpactUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdLocationsUrl(
  project_id: GetApiProjectsProjectIdLocationsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/locations` as const,
  };
  return res;
}

/**
 * @summary Retrieves locations
 * {@link /api/projects/:project_id/locations}
 */
export async function getApiProjectsProjectIdLocations(
  project_id: GetApiProjectsProjectIdLocationsPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdLocationsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdLocationsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocations401Schema
      | GetApiProjectsProjectIdLocations403Schema
      | GetApiProjectsProjectIdLocations404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdLocationsUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdLocationsUrl(
  project_id: PostApiProjectsProjectIdLocationsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/locations` as const,
  };
  return res;
}

/**
 * @summary Creates a location
 * {@link /api/projects/:project_id/locations}
 */
export async function postApiProjectsProjectIdLocations(
  project_id: PostApiProjectsProjectIdLocationsPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdLocationsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdLocationsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdLocationsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdLocations401Schema
      | PostApiProjectsProjectIdLocations403Schema
      | PostApiProjectsProjectIdLocations404Schema
      | PostApiProjectsProjectIdLocations422Schema
    >,
    PostApiProjectsProjectIdLocationsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdLocationsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdLocationsLocationIdUrl(
  project_id: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema['project_id'],
  location_id: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema['location_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/locations/${location_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a location
 * {@link /api/projects/:project_id/locations/:location_id}
 */
export async function patchApiProjectsProjectIdLocationsLocationId(
  project_id: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema['project_id'],
  location_id: PatchApiProjectsProjectIdLocationsLocationIdPathParamsSchema['location_id'],
  data?: PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdLocationsLocationId401Schema
      | PatchApiProjectsProjectIdLocationsLocationId403Schema
      | PatchApiProjectsProjectIdLocationsLocationId404Schema
      | PatchApiProjectsProjectIdLocationsLocationId422Schema
    >,
    PatchApiProjectsProjectIdLocationsLocationIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdLocationsLocationIdUrl(project_id, location_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdLocationsLocationIdUrl(
  project_id: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema['project_id'],
  location_id: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema['location_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/locations/${location_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a location
 * {@link /api/projects/:project_id/locations/:location_id}
 */
export async function getApiProjectsProjectIdLocationsLocationId(
  project_id: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema['project_id'],
  location_id: GetApiProjectsProjectIdLocationsLocationIdPathParamsSchema['location_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdLocationsLocationIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLocationsLocationId401Schema
      | GetApiProjectsProjectIdLocationsLocationId403Schema
      | GetApiProjectsProjectIdLocationsLocationId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdLocationsLocationIdUrl(project_id, location_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdLocationsLocationIdUrl(
  project_id: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema['project_id'],
  location_id: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema['location_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/locations/${location_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a location
 * {@link /api/projects/:project_id/locations/:location_id}
 */
export async function deleteApiProjectsProjectIdLocationsLocationId(
  project_id: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema['project_id'],
  location_id: DeleteApiProjectsProjectIdLocationsLocationIdPathParamsSchema['location_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdLocationsLocationIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdLocationsLocationId401Schema
      | DeleteApiProjectsProjectIdLocationsLocationId403Schema
      | DeleteApiProjectsProjectIdLocationsLocationId404Schema
      | DeleteApiProjectsProjectIdLocationsLocationId422Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdLocationsLocationIdUrl(project_id, location_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdLocationsLocationIdSortUrl(
  project_id: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema['project_id'],
  location_id: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema['location_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/locations/${location_id}/sort` as const,
  };
  return res;
}

/**
 * @summary Sorts locations
 * {@link /api/projects/:project_id/locations/:location_id/sort}
 */
export async function postApiProjectsProjectIdLocationsLocationIdSort(
  project_id: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema['project_id'],
  location_id: PostApiProjectsProjectIdLocationsLocationIdSortPathParamsSchema['location_id'],
  data?: PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdLocationsLocationIdSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdLocationsLocationIdSort401Schema
      | PostApiProjectsProjectIdLocationsLocationIdSort403Schema
      | PostApiProjectsProjectIdLocationsLocationIdSort404Schema
    >,
    PostApiProjectsProjectIdLocationsLocationIdSortMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdLocationsLocationIdSortUrl(project_id, location_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsUrl(
  project_id: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema['project_id'],
  log_person_id: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema['log_person_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/logs/people/${log_person_id}/allocations` as const,
  };
  return res;
}

/**
 * @summary Retrieves allocations for a person log
 * {@link /api/projects/:project_id/logs/people/:log_person_id/allocations}
 */
export async function getApiProjectsProjectIdLogsPeopleLogPersonIdAllocations(
  project_id: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema['project_id'],
  log_person_id: GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsPathParamsSchema['log_person_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdAllocations404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdLogsPeopleLogPersonIdAllocationsUrl(project_id, log_person_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsUrl(
  project_id: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema['project_id'],
  log_person_id: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema['log_person_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/logs/people/${log_person_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Retrieves person log documents
 * {@link /api/projects/:project_id/logs/people/:log_person_id/documents}
 */
export async function getApiProjectsProjectIdLogsPeopleLogPersonIdDocuments(
  project_id: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema['project_id'],
  log_person_id: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsPathParamsSchema['log_person_id'],
  params?: GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments400Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments401Schema
      | GetApiProjectsProjectIdLogsPeopleLogPersonIdDocuments404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdLogsPeopleLogPersonIdDocumentsUrl(project_id, log_person_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdLogsPeopleUrl(
  project_id: GetApiProjectsProjectIdLogsPeoplePathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/logs/people` as const,
  };
  return res;
}

/**
 * @summary Retrieves people logs
 * {@link /api/projects/:project_id/logs/people}
 */
export async function getApiProjectsProjectIdLogsPeople(
  project_id: GetApiProjectsProjectIdLogsPeoplePathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdLogsPeopleQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdLogsPeopleQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdLogsPeople401Schema
      | GetApiProjectsProjectIdLogsPeople403Schema
      | GetApiProjectsProjectIdLogsPeople404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdLogsPeopleUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiOrgsUrl() {
  const res = { method: 'POST', url: `/api/orgs` as const };
  return res;
}

/**
 * @summary Creates an org
 * {@link /api/orgs}
 */
export async function postApiOrgs(
  data?: PostApiOrgsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiOrgsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiOrgsMutationResponseSchema,
    ResponseErrorConfig<PostApiOrgs400Schema | PostApiOrgs401Schema | PostApiOrgs422Schema>,
    PostApiOrgsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiOrgsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiOrgsUrl() {
  const res = { method: 'GET', url: `/api/orgs` as const };
  return res;
}

/**
 * @summary Retrieves orgs
 * {@link /api/orgs}
 */
export async function getApiOrgs(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<GetApiOrgsQueryResponseSchema, ResponseErrorConfig<GetApiOrgs401Schema>, unknown>({
    method: 'GET',
    url: getGetApiOrgsUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiOrgsOrgIdUrl(org_id: PatchApiOrgsOrgIdPathParamsSchema['org_id']) {
  const res = { method: 'PATCH', url: `/api/orgs/${org_id}` as const };
  return res;
}

/**
 * @summary Updates an org
 * {@link /api/orgs/:org_id}
 */
export async function patchApiOrgsOrgId(
  org_id: PatchApiOrgsOrgIdPathParamsSchema['org_id'],
  data?: PatchApiOrgsOrgIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiOrgsOrgIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiOrgsOrgIdMutationResponseSchema,
    ResponseErrorConfig<PatchApiOrgsOrgId401Schema>,
    PatchApiOrgsOrgIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiOrgsOrgIdUrl(org_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiOrgsOrgIdUrl(org_id: GetApiOrgsOrgIdPathParamsSchema['org_id']) {
  const res = { method: 'GET', url: `/api/orgs/${org_id}` as const };
  return res;
}

/**
 * @summary Retrieves an org
 * {@link /api/orgs/:org_id}
 */
export async function getApiOrgsOrgId(
  org_id: GetApiOrgsOrgIdPathParamsSchema['org_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiOrgsOrgIdQueryResponseSchema,
    ResponseErrorConfig<GetApiOrgsOrgId401Schema | GetApiOrgsOrgId403Schema | GetApiOrgsOrgId404Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiOrgsOrgIdUrl(org_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiOrgsCheckDomainUrl() {
  const res = { method: 'POST', url: `/api/orgs/check_domain` as const };
  return res;
}

/**
 * @summary Checks org domain
 * {@link /api/orgs/check_domain}
 */
export async function postApiOrgsCheckDomain(
  data?: PostApiOrgsCheckDomainMutationRequestSchema,
  config: Partial<RequestConfig<PostApiOrgsCheckDomainMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiOrgsCheckDomainMutationResponseSchema,
    ResponseErrorConfig<PostApiOrgsCheckDomain401Schema>,
    PostApiOrgsCheckDomainMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiOrgsCheckDomainUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiOrgsOrgIdResendVerificationEmailUrl(
  org_id: PostApiOrgsOrgIdResendVerificationEmailPathParamsSchema['org_id']
) {
  const res = {
    method: 'POST',
    url: `/api/orgs/${org_id}/resend_verification_email` as const,
  };
  return res;
}

/**
 * @summary Resends verification email
 * {@link /api/orgs/:org_id/resend_verification_email}
 */
export async function postApiOrgsOrgIdResendVerificationEmail(
  org_id: PostApiOrgsOrgIdResendVerificationEmailPathParamsSchema['org_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiOrgsOrgIdResendVerificationEmailMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiOrgsOrgIdResendVerificationEmail401Schema
      | PostApiOrgsOrgIdResendVerificationEmail403Schema
      | PostApiOrgsOrgIdResendVerificationEmail404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiOrgsOrgIdResendVerificationEmailUrl(org_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetWellKnownJwksJsonUrl() {
  const res = { method: 'GET', url: `/.well-known/jwks.json` as const };
  return res;
}

/**
 * @summary Retrieves the JWKS for PowerSync token verification
 * {@link /.well-known/jwks.json}
 */
export async function getWellKnownJwksJson(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetWellKnownJwksJsonQueryResponseSchema,
    ResponseErrorConfig<GetWellKnownJwksJson503Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetWellKnownJwksJsonUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiPowerSyncTokenUrl() {
  const res = { method: 'POST', url: `/api/power_sync/token` as const };
  return res;
}

/**
 * @summary Creates a PowerSync authentication token
 * {@link /api/power_sync/token}
 */
export async function postApiPowerSyncToken(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiPowerSyncTokenMutationResponseSchema,
    ResponseErrorConfig<PostApiPowerSyncToken401Schema>,
    unknown
  >({
    method: 'POST',
    url: getPostApiPowerSyncTokenUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdUrl(
  project_id: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema['project_id'],
  progress_log_id: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema['progress_log_id'],
  document_reference_id: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema['document_reference_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/progress_logs/${progress_log_id}/document_references/${document_reference_id}` as const,
  };
  return res;
}

/**
 * @summary Removes a document from a progress log
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id/document_references/:document_reference_id}
 */
export async function deleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId(
  project_id: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema['project_id'],
  progress_log_id: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema['progress_log_id'],
  document_reference_id: DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdPathParamsSchema['document_reference_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdProgressLogsProgressLogIdDocumentReferencesDocumentReferenceIdUrl(
      project_id,
      progress_log_id,
      document_reference_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsUrl(
  project_id: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema['project_id'],
  progress_log_id: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema['progress_log_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/progress_logs/${progress_log_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Retrieves progress log documents
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id/documents}
 */
export async function getApiProjectsProjectIdProgressLogsProgressLogIdDocuments(
  project_id: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema['project_id'],
  progress_log_id: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema['progress_log_id'],
  params?: GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdProgressLogsProgressLogIdDocumentsUrl(project_id, progress_log_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsUrl(
  project_id: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema['project_id'],
  progress_log_id: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema['progress_log_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/progress_logs/${progress_log_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Adds a document to a progress log (from an upload or an existing document)
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id/documents}
 */
export async function postApiProjectsProjectIdProgressLogsProgressLogIdDocuments(
  project_id: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema['project_id'],
  progress_log_id: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsPathParamsSchema['progress_log_id'],
  data?: PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments400Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments401Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments404Schema
      | PostApiProjectsProjectIdProgressLogsProgressLogIdDocuments422Schema
    >,
    PostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdProgressLogsProgressLogIdDocumentsUrl(project_id, progress_log_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdProgressLogsUrl(
  project_id: GetApiProjectsProjectIdProgressLogsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/progress_logs` as const,
  };
  return res;
}

/**
 * @summary Retrieves progress logs
 * {@link /api/projects/:project_id/progress_logs}
 */
export async function getApiProjectsProjectIdProgressLogs(
  project_id: GetApiProjectsProjectIdProgressLogsPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdProgressLogsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdProgressLogsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogs401Schema
      | GetApiProjectsProjectIdProgressLogs403Schema
      | GetApiProjectsProjectIdProgressLogs404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdProgressLogsUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdProgressLogsUrl(
  project_id: PostApiProjectsProjectIdProgressLogsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/progress_logs` as const,
  };
  return res;
}

/**
 * @summary Creates a progress log
 * {@link /api/projects/:project_id/progress_logs}
 */
export async function postApiProjectsProjectIdProgressLogs(
  project_id: PostApiProjectsProjectIdProgressLogsPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdProgressLogsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdProgressLogsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdProgressLogsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdProgressLogs401Schema
      | PostApiProjectsProjectIdProgressLogs403Schema
      | PostApiProjectsProjectIdProgressLogs404Schema
      | PostApiProjectsProjectIdProgressLogs422Schema
    >,
    PostApiProjectsProjectIdProgressLogsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdProgressLogsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdProgressLogsProgressLogIdUrl(
  project_id: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema['project_id'],
  progress_log_id: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema['progress_log_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/progress_logs/${progress_log_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a progress log
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id}
 */
export async function getApiProjectsProjectIdProgressLogsProgressLogId(
  project_id: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema['project_id'],
  progress_log_id: GetApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema['progress_log_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdProgressLogsProgressLogIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdProgressLogsProgressLogId401Schema
      | GetApiProjectsProjectIdProgressLogsProgressLogId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdProgressLogsProgressLogIdUrl(project_id, progress_log_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdProgressLogsProgressLogIdUrl(
  project_id: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema['project_id'],
  progress_log_id: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema['progress_log_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/progress_logs/${progress_log_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a progress log
 * {@link /api/projects/:project_id/progress_logs/:progress_log_id}
 */
export async function patchApiProjectsProjectIdProgressLogsProgressLogId(
  project_id: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema['project_id'],
  progress_log_id: PatchApiProjectsProjectIdProgressLogsProgressLogIdPathParamsSchema['progress_log_id'],
  data?: PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdProgressLogsProgressLogId401Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId403Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId404Schema
      | PatchApiProjectsProjectIdProgressLogsProgressLogId422Schema
    >,
    PatchApiProjectsProjectIdProgressLogsProgressLogIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdProgressLogsProgressLogIdUrl(project_id, progress_log_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdAccessRequestsUrl(
  project_id: GetApiProjectsProjectIdAccessRequestsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/access_requests` as const,
  };
  return res;
}

/**
 * @summary Retrieves project pending access requests
 * {@link /api/projects/:project_id/access_requests}
 */
export async function getApiProjectsProjectIdAccessRequests(
  project_id: GetApiProjectsProjectIdAccessRequestsPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdAccessRequestsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdAccessRequestsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequests400Schema
      | GetApiProjectsProjectIdAccessRequests401Schema
      | GetApiProjectsProjectIdAccessRequests403Schema
      | GetApiProjectsProjectIdAccessRequests404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdAccessRequestsUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdAccessRequestsUrl(
  project_id: PostApiProjectsProjectIdAccessRequestsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/access_requests` as const,
  };
  return res;
}

/**
 * @summary Creates a project access request
 * {@link /api/projects/:project_id/access_requests}
 */
export async function postApiProjectsProjectIdAccessRequests(
  project_id: PostApiProjectsProjectIdAccessRequestsPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdAccessRequestsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdAccessRequestsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdAccessRequestsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequests400Schema
      | PostApiProjectsProjectIdAccessRequests401Schema
      | PostApiProjectsProjectIdAccessRequests404Schema
      | PostApiProjectsProjectIdAccessRequests422Schema
    >,
    PostApiProjectsProjectIdAccessRequestsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdAccessRequestsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdUrl(
  project_id: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema['project_id'],
  project_access_request_id: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema['project_access_request_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/access_requests/${project_access_request_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a project access request
 * {@link /api/projects/:project_id/access_requests/:project_access_request_id}
 */
export async function getApiProjectsProjectIdAccessRequestsProjectAccessRequestId(
  project_id: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema['project_id'],
  project_access_request_id: GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdPathParamsSchema['project_access_request_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId401Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId403Schema
      | GetApiProjectsProjectIdAccessRequestsProjectAccessRequestId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdAccessRequestsProjectAccessRequestIdUrl(
      project_id,
      project_access_request_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptUrl(
  project_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema['project_id'],
  project_access_request_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema['project_access_request_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/access_requests/${project_access_request_id}/accept` as const,
  };
  return res;
}

/**
 * @summary Accepts a project access request
 * {@link /api/projects/:project_id/access_requests/:project_access_request_id/accept}
 */
export async function postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept(
  project_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema['project_id'],
  project_access_request_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptPathParamsSchema['project_access_request_id'],
  data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept404Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAccept422Schema
    >,
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdAcceptUrl(
      project_id,
      project_access_request_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectUrl(
  project_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema['project_id'],
  project_access_request_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema['project_access_request_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/access_requests/${project_access_request_id}/reject` as const,
  };
  return res;
}

/**
 * @summary Rejects a project access request
 * {@link /api/projects/:project_id/access_requests/:project_access_request_id/reject}
 */
export async function postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject(
  project_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema['project_id'],
  project_access_request_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectPathParamsSchema['project_access_request_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdReject404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRejectUrl(
      project_id,
      project_access_request_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectUrl(
  project_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema['project_id'],
  project_access_request_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema['project_access_request_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/access_requests/${project_access_request_id}/redirect` as const,
  };
  return res;
}

/**
 * @summary Redirects a project access request to another team
 * {@link /api/projects/:project_id/access_requests/:project_access_request_id/redirect}
 */
export async function postApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect(
  project_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema['project_id'],
  project_access_request_id: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectPathParamsSchema['project_access_request_id'],
  data: PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect400Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect401Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect403Schema
      | PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirect404Schema
    >,
    PostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdAccessRequestsProjectAccessRequestIdRedirectUrl(
      project_id,
      project_access_request_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdPeopleUrl(project_id: GetApiProjectsProjectIdPeoplePathParamsSchema['project_id']) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/people` as const,
  };
  return res;
}

/**
 * @description Excludes archived team members by default, unless status is given
 * @summary Retrieves project people
 * {@link /api/projects/:project_id/people}
 */
export async function getApiProjectsProjectIdPeople(
  project_id: GetApiProjectsProjectIdPeoplePathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdPeopleQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdPeopleQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeople400Schema
      | GetApiProjectsProjectIdPeople401Schema
      | GetApiProjectsProjectIdPeople403Schema
      | GetApiProjectsProjectIdPeople404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdPeopleUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdPeopleTeamMemberIdUrl(
  project_id: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema['project_id'],
  team_member_id: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema['team_member_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/people/${team_member_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a team member
 * {@link /api/projects/:project_id/people/:team_member_id}
 */
export async function getApiProjectsProjectIdPeopleTeamMemberId(
  project_id: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema['project_id'],
  team_member_id: GetApiProjectsProjectIdPeopleTeamMemberIdPathParamsSchema['team_member_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdPeopleTeamMemberIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdPeopleTeamMemberId401Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId403Schema
      | GetApiProjectsProjectIdPeopleTeamMemberId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdPeopleTeamMemberIdUrl(project_id, team_member_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdFilesIdUrl(
  project_id: GetApiProjectsProjectIdFilesIdPathParamsSchema['project_id'],
  id: GetApiProjectsProjectIdFilesIdPathParamsSchema['id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/files/${id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a file download URL
 * {@link /api/projects/:project_id/files/:id}
 */
export async function getApiProjectsProjectIdFilesId(
  project_id: GetApiProjectsProjectIdFilesIdPathParamsSchema['project_id'],
  id: GetApiProjectsProjectIdFilesIdPathParamsSchema['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdFilesIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdFilesId401Schema
      | GetApiProjectsProjectIdFilesId403Schema
      | GetApiProjectsProjectIdFilesId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdFilesIdUrl(project_id, id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiNotificationsOverviewUrl() {
  const res = { method: 'GET', url: `/api/notifications/overview` as const };
  return res;
}

/**
 * @summary Retrieves notifications overview
 * {@link /api/notifications/overview}
 */
export async function getApiNotificationsOverview(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiNotificationsOverviewQueryResponseSchema,
    ResponseErrorConfig<GetApiNotificationsOverview401Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiNotificationsOverviewUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdNotificationsUrl(
  project_id: GetApiProjectsProjectIdNotificationsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/notifications` as const,
  };
  return res;
}

/**
 * @summary Retrieves notifications
 * {@link /api/projects/:project_id/notifications}
 */
export async function getApiProjectsProjectIdNotifications(
  project_id: GetApiProjectsProjectIdNotificationsPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdNotificationsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdNotificationsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdNotifications400Schema
      | GetApiProjectsProjectIdNotifications401Schema
      | GetApiProjectsProjectIdNotifications404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdNotificationsUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdNotificationsNotificationIdMarkReadUrl(
  project_id: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema['project_id'],
  notification_id: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema['notification_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/notifications/${notification_id}/mark_read` as const,
  };
  return res;
}

/**
 * @summary Marks notification as read
 * {@link /api/projects/:project_id/notifications/:notification_id/mark_read}
 */
export async function postApiProjectsProjectIdNotificationsNotificationIdMarkRead(
  project_id: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema['project_id'],
  notification_id: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadPathParamsSchema['notification_id'],
  data?: PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead401Schema
      | PostApiProjectsProjectIdNotificationsNotificationIdMarkRead404Schema
    >,
    PostApiProjectsProjectIdNotificationsNotificationIdMarkReadMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdNotificationsNotificationIdMarkReadUrl(project_id, notification_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdNotificationsMarkAllReadUrl(
  project_id: PostApiProjectsProjectIdNotificationsMarkAllReadPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/notifications/mark_all_read` as const,
  };
  return res;
}

/**
 * @summary Marks all notifications as read
 * {@link /api/projects/:project_id/notifications/mark_all_read}
 */
export async function postApiProjectsProjectIdNotificationsMarkAllRead(
  project_id: PostApiProjectsProjectIdNotificationsMarkAllReadPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdNotificationsMarkAllReadMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsProjectIdNotificationsMarkAllRead401Schema>,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdNotificationsMarkAllReadUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsUrl() {
  const res = { method: 'POST', url: `/api/projects` as const };
  return res;
}

/**
 * @summary Creates a project
 * {@link /api/projects}
 */
export async function postApiProjects(
  data?: PostApiProjectsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsMutationResponseSchema,
    ResponseErrorConfig<PostApiProjects401Schema | PostApiProjects403Schema>,
    PostApiProjectsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsUrl() {
  const res = { method: 'GET', url: `/api/projects` as const };
  return res;
}

/**
 * @summary Retrieves projects
 * {@link /api/projects}
 */
export async function getApiProjects(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsQueryResponseSchema,
    ResponseErrorConfig<GetApiProjects401Schema | GetApiProjects403Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdUrl(project_id: GetApiProjectsProjectIdPathParamsSchema['project_id']) {
  const res = { method: 'GET', url: `/api/projects/${project_id}` as const };
  return res;
}

/**
 * @summary Retrieves a project
 * {@link /api/projects/:project_id}
 */
export async function getApiProjectsProjectId(
  project_id: GetApiProjectsProjectIdPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdQueryResponseSchema,
    ResponseErrorConfig<
      GetApiProjectsProjectId401Schema | GetApiProjectsProjectId403Schema | GetApiProjectsProjectId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdUrl(project_id: PatchApiProjectsProjectIdPathParamsSchema['project_id']) {
  const res = { method: 'PATCH', url: `/api/projects/${project_id}` as const };
  return res;
}

/**
 * @summary Updates a project
 * {@link /api/projects/:project_id}
 */
export async function patchApiProjectsProjectId(
  project_id: PatchApiProjectsProjectIdPathParamsSchema['project_id'],
  data?: PatchApiProjectsProjectIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectId401Schema
      | PatchApiProjectsProjectId403Schema
      | PatchApiProjectsProjectId404Schema
      | PatchApiProjectsProjectId422Schema
    >,
    PatchApiProjectsProjectIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdArchiveUrl(
  project_id: PostApiProjectsProjectIdArchivePathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/archive` as const,
  };
  return res;
}

/**
 * @summary Archives a project
 * {@link /api/projects/:project_id/archive}
 */
export async function postApiProjectsProjectIdArchive(
  project_id: PostApiProjectsProjectIdArchivePathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdArchive401Schema
      | PostApiProjectsProjectIdArchive403Schema
      | PostApiProjectsProjectIdArchive404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdArchiveUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiQueuedTasksUrl() {
  const res = { method: 'GET', url: `/api/queued_tasks` as const };
  return res;
}

/**
 * @summary Retrieves queued tasks
 * {@link /api/queued_tasks}
 */
export async function getApiQueuedTasks(
  params: GetApiQueuedTasksQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiQueuedTasksQueryResponseSchema,
    ResponseErrorConfig<GetApiQueuedTasks400Schema | GetApiQueuedTasks401Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiQueuedTasksUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftActivitiesUrl(
  project_id: GetApiProjectsProjectIdShiftActivitiesPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_activities` as const,
  };
  return res;
}

/**
 * @summary Retrieves shift activities
 * {@link /api/projects/:project_id/shift_activities}
 */
export async function getApiProjectsProjectIdShiftActivities(
  project_id: GetApiProjectsProjectIdShiftActivitiesPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdShiftActivitiesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftActivitiesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivities400Schema
      | GetApiProjectsProjectIdShiftActivities401Schema
      | GetApiProjectsProjectIdShiftActivities403Schema
      | GetApiProjectsProjectIdShiftActivities404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftActivitiesUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftActivitiesUrl(
  project_id: PostApiProjectsProjectIdShiftActivitiesPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_activities` as const,
  };
  return res;
}

/**
 * @summary Creates a shift activity
 * {@link /api/projects/:project_id/shift_activities}
 */
export async function postApiProjectsProjectIdShiftActivities(
  project_id: PostApiProjectsProjectIdShiftActivitiesPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftActivitiesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivities401Schema
      | PostApiProjectsProjectIdShiftActivities403Schema
      | PostApiProjectsProjectIdShiftActivities404Schema
      | PostApiProjectsProjectIdShiftActivities422Schema
    >,
    PostApiProjectsProjectIdShiftActivitiesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftActivitiesUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdUrl(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a shift activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id}
 */
export async function getApiProjectsProjectIdShiftActivitiesShiftActivityId(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema['shift_activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdUrl(project_id, shift_activity_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdShiftActivitiesShiftActivityIdUrl(
  project_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema['project_id'],
  shift_activity_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a shift activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id}
 */
export async function patchApiProjectsProjectIdShiftActivitiesShiftActivityId(
  project_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema['project_id'],
  shift_activity_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdPathParamsSchema['shift_activity_id'],
  data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId404Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityId422Schema
    >,
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdShiftActivitiesShiftActivityIdUrl(project_id, shift_activity_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveUrl(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/archive` as const,
  };
  return res;
}

/**
 * @summary Archives a shift activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/archive}
 */
export async function postApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchivePathParamsSchema['shift_activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchive422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdArchiveUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreUrl(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/restore` as const,
  };
  return res;
}

/**
 * @summary Restores a shift activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/restore}
 */
export async function postApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestorePathParamsSchema['shift_activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestore422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdRestoreUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersUrl(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/blockers` as const,
  };
  return res;
}

/**
 * @summary Retrieves shift activity blockers
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/blockers}
 */
export async function getApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersPathParamsSchema['shift_activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockers404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchUrl(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/blockers/batch` as const,
  };
  return res;
}

/**
 * @summary Creates a batch of shift activity blockers
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/blockers/batch}
 */
export async function postApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchPathParamsSchema['shift_activity_id'],
  data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch400Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatch404Schema
    >,
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersBatchUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdUrl(
  project_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema['project_id'],
  shift_activity_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema['shift_activity_id'],
  shift_activity_blocker_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema['shift_activity_blocker_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/blockers/${shift_activity_blocker_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a shift activity blocker
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/blockers/:shift_activity_blocker_id}
 */
export async function deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId(
  project_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema['project_id'],
  shift_activity_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema['shift_activity_id'],
  shift_activity_blocker_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdPathParamsSchema['shift_activity_blocker_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdBlockersShiftActivityBlockerIdUrl(
      project_id,
      shift_activity_id,
      shift_activity_blocker_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressUrl(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/daily_progress` as const,
  };
  return res;
}

/**
 * @summary Retrieves a shift activity weekly work plans
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/daily_progress}
 */
export async function getApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressPathParamsSchema['shift_activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgress404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdDailyProgressUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsUrl(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Retrieves a shift activity documents
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/documents}
 */
export async function getApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsPathParamsSchema['shift_activity_id'],
  params?: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocuments404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdDocumentsUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftActivitiesExportUrl(
  project_id: PostApiProjectsProjectIdShiftActivitiesExportPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_activities/export` as const,
  };
  return res;
}

/**
 * @summary Exports a list of shift activities
 * {@link /api/projects/:project_id/shift_activities/export}
 */
export async function postApiProjectsProjectIdShiftActivitiesExport(
  project_id: PostApiProjectsProjectIdShiftActivitiesExportPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftActivitiesExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesExport401Schema
      | PostApiProjectsProjectIdShiftActivitiesExport403Schema
      | PostApiProjectsProjectIdShiftActivitiesExport404Schema
    >,
    PostApiProjectsProjectIdShiftActivitiesExportMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftActivitiesExportUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftActivitiesImportsUrl(
  project_id: PostApiProjectsProjectIdShiftActivitiesImportsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_activities/imports` as const,
  };
  return res;
}

/**
 * @summary Creates a shift activity import
 * {@link /api/projects/:project_id/shift_activities/imports}
 */
export async function postApiProjectsProjectIdShiftActivitiesImports(
  project_id: PostApiProjectsProjectIdShiftActivitiesImportsPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiProjectsProjectIdShiftActivitiesImportsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesImports401Schema
      | PostApiProjectsProjectIdShiftActivitiesImports403Schema
      | PostApiProjectsProjectIdShiftActivitiesImports404Schema
      | PostApiProjectsProjectIdShiftActivitiesImports422Schema
    >,
    PostApiProjectsProjectIdShiftActivitiesImportsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftActivitiesImportsUrl(project_id).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessUrl(
  project_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema['project_id'],
  shift_activity_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/readiness` as const,
  };
  return res;
}

/**
 * @summary Updates shift activity readiness
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/readiness}
 */
export async function patchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness(
  project_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema['project_id'],
  shift_activity_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessPathParamsSchema['shift_activity_id'],
  data: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema,
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness400Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadiness404Schema
    >,
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdShiftActivitiesShiftActivityIdReadinessUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsUrl(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/requirements` as const,
  };
  return res;
}

/**
 * @summary Retrieves the shift activity requirements
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements}
 */
export async function getApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema['shift_activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsUrl(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/requirements` as const,
  };
  return res;
}

/**
 * @summary Creates a shift activity requirement
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements}
 */
export async function postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsPathParamsSchema['shift_activity_id'],
  data?: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements404Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirements422Schema
    >,
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortUrl(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/requirements/sort` as const,
  };
  return res;
}

/**
 * @summary Sorts shift activity requirements
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/sort}
 */
export async function postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortPathParamsSchema['shift_activity_id'],
  data: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort400Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSort404Schema
    >,
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsSortUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdUrl(
  project_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['project_id'],
  shift_activity_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['shift_activity_id'],
  requirement_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['requirement_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/requirements/${requirement_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a shift activity requirement
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id}
 */
export async function patchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId(
  project_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['project_id'],
  shift_activity_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['shift_activity_id'],
  requirement_id: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['requirement_id'],
  data?: PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema,
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
      | PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId422Schema
    >,
    PatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdUrl(
      project_id,
      shift_activity_id,
      requirement_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdUrl(
  project_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['project_id'],
  shift_activity_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['shift_activity_id'],
  requirement_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['requirement_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/requirements/${requirement_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a shift activity requirement
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id}
 */
export async function deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId(
  project_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['project_id'],
  shift_activity_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['shift_activity_id'],
  requirement_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdPathParamsSchema['requirement_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdUrl(
      project_id,
      shift_activity_id,
      requirement_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionUrl(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['shift_activity_id'],
  requirement_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['requirement_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/requirements/${requirement_id}/completion` as const,
  };
  return res;
}

/**
 * @summary Marks shift activity requirement as completed
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id/completion}
 */
export async function postApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion(
  project_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['project_id'],
  shift_activity_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['shift_activity_id'],
  requirement_id: PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['requirement_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
      | PostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionUrl(
      project_id,
      shift_activity_id,
      requirement_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionUrl(
  project_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['project_id'],
  shift_activity_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['shift_activity_id'],
  requirement_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['requirement_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/requirements/${requirement_id}/completion` as const,
  };
  return res;
}

/**
 * @summary Marks shift activity requirement as incomplete
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/requirements/:requirement_id/completion}
 */
export async function deleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion(
  project_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['project_id'],
  shift_activity_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['shift_activity_id'],
  requirement_id: DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionPathParamsSchema['requirement_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion401Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion403Schema
      | DeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletion404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdShiftActivitiesShiftActivityIdRequirementsRequirementIdCompletionUrl(
      project_id,
      shift_activity_id,
      requirement_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageUrl(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/resources_usage` as const,
  };
  return res;
}

/**
 * @summary Retrieves a shift activity resources usage material list
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage}
 */
export async function getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsagePathParamsSchema['shift_activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsage404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsUrl(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/resources_usage/stats` as const,
  };
  return res;
}

/**
 * @summary Retrieves a shift activity resources usage stats
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/resources_usage/stats}
 */
export async function getApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsPathParamsSchema['shift_activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStats404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdResourcesUsageStatsUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningUrl(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema['shift_activity_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_activities/${shift_activity_id}/weekly_planning` as const,
  };
  return res;
}

/**
 * @summary Retrieves the weekly planning items of an activity
 * {@link /api/projects/:project_id/shift_activities/:shift_activity_id/weekly_planning}
 */
export async function getApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning(
  project_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema['project_id'],
  shift_activity_id: GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningPathParamsSchema['shift_activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning401Schema
      | GetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanning404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftActivitiesShiftActivityIdWeeklyPlanningUrl(
      project_id,
      shift_activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/activities/batch_create` as const,
  };
  return res;
}

/**
 * @summary Batch create shift report activities and people allocations from progress logs
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/activities/batch_create}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreatePathParamsSchema['shift_report_id'],
  data: PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreate422Schema
    >,
    PostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdActivitiesBatchCreateUrl(
      project_id,
      shift_report_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsUrl(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/comments/collaborators` as const,
  };
  return res;
}

/**
 * @summary Retrieves shift report collaborators comments
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/collaborators}
 */
export async function getApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema['shift_report_id'],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsUrl(
      project_id,
      shift_report_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/comments/collaborators` as const,
  };
  return res;
}

/**
 * @summary Creates a shift report collaborators comment
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/collaborators}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsPathParamsSchema['shift_report_id'],
  data?: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaborators422Schema
    >,
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdCommentsCollaboratorsUrl(
      project_id,
      shift_report_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicUrl(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/comments/public` as const,
  };
  return res;
}

/**
 * @summary Retrieves shift report public comments
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/public}
 */
export async function getApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema['shift_report_id'],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicUrl(
      project_id,
      shift_report_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/comments/public` as const,
  };
  return res;
}

/**
 * @summary Creates a shift report public comment
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/public}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicPathParamsSchema['shift_report_id'],
  data: PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublic404Schema
    >,
    PostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdCommentsPublicUrl(
      project_id,
      shift_report_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdUrl(
  project_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema['project_id'],
  shift_report_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema['shift_report_id'],
  comment_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema['comment_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/comments/${comment_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a shift report comment
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/comments/:comment_id}
 */
export async function deleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId(
  project_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema['project_id'],
  shift_report_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema['shift_report_id'],
  comment_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdPathParamsSchema['comment_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId404Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentId422Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdShiftReportsShiftReportIdCommentsCommentIdUrl(
      project_id,
      shift_report_id,
      comment_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdUrl(
  project_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema['project_id'],
  shift_report_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema['shift_report_id'],
  document_reference_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema['document_reference_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/document_references/${document_reference_id}` as const,
  };
  return res;
}

/**
 * @summary Removes a document from a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/document_references/:document_reference_id}
 */
export async function deleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId(
  project_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema['project_id'],
  shift_report_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema['shift_report_id'],
  document_reference_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdPathParamsSchema['document_reference_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdShiftReportsShiftReportIdDocumentReferencesDocumentReferenceIdUrl(
      project_id,
      shift_report_id,
      document_reference_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsUrl(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Retrieves shift report documents
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/documents}
 */
export async function getApiProjectsProjectIdShiftReportsShiftReportIdDocuments(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema['shift_report_id'],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdDocuments404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsShiftReportIdDocumentsUrl(project_id, shift_report_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Adds a document to a shift report (from an upload or an existing document)
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/documents}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdDocuments(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsPathParamsSchema['shift_report_id'],
  data?: PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdDocuments422Schema
    >,
    PostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdDocumentsUrl(project_id, shift_report_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsExportUrl(
  project_id: PostApiProjectsProjectIdShiftReportsExportPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/export` as const,
  };
  return res;
}

/**
 * @summary Exports a list of shift reports
 * {@link /api/projects/:project_id/shift_reports/export}
 */
export async function postApiProjectsProjectIdShiftReportsExport(
  project_id: PostApiProjectsProjectIdShiftReportsExportPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsExport400Schema
      | PostApiProjectsProjectIdShiftReportsExport401Schema
      | PostApiProjectsProjectIdShiftReportsExport403Schema
      | PostApiProjectsProjectIdShiftReportsExport404Schema
    >,
    PostApiProjectsProjectIdShiftReportsExportMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsExportUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdExportUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/export` as const,
  };
  return res;
}

/**
 * @summary Exports a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/export}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdExport(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdExportPathParamsSchema['shift_report_id'],
  params: PostApiProjectsProjectIdShiftReportsShiftReportIdExportQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdExport404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdExportUrl(project_id, shift_report_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdImportUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/import` as const,
  };
  return res;
}

/**
 * @summary Imports data from an XLSX file to a draft shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/import}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdImport(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdImportPathParamsSchema['shift_report_id'],
  data?: PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdImport422Schema
    >,
    PostApiProjectsProjectIdShiftReportsShiftReportIdImportMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdImportUrl(project_id, shift_report_id).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsShiftReportIdPeopleUrl(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/people` as const,
  };
  return res;
}

/**
 * @summary Retrieves team members with access to shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/people}
 */
export async function getApiProjectsProjectIdShiftReportsShiftReportIdPeople(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdPeoplePathParamsSchema['shift_report_id'],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsShiftReportIdPeopleQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdPeople404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsShiftReportIdPeopleUrl(project_id, shift_report_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsUrl(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['shift_report_id'],
  resource_type: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['resource_type'],
  resource_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['resource_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/${resource_type}/${resource_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Retrieves shift report resource documents
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents}
 */
export async function getApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['shift_report_id'],
  resource_type: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['resource_type'],
  resource_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['resource_id'],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsUrl(
      project_id,
      shift_report_id,
      resource_type,
      resource_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['shift_report_id'],
  resource_type: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['resource_type'],
  resource_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['resource_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/${resource_type}/${resource_id}/documents` as const,
  };
  return res;
}

/**
 * @summary Adds a document to a shift report resource (from an upload or an existing document)
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['shift_report_id'],
  resource_type: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['resource_type'],
  resource_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsPathParamsSchema['resource_id'],
  data?: PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocuments422Schema
    >,
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsUrl(
      project_id,
      shift_report_id,
      resource_type,
      resource_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdUrl(
  project_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['project_id'],
  shift_report_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['shift_report_id'],
  document_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['document_id'],
  resource_type: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['resource_type'],
  resource_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['resource_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/${resource_type}/${resource_id}/documents/${document_id}` as const,
  };
  return res;
}

/**
 * @summary Removes a document from a shift report resource
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/:resource_type/:resource_id/documents/:document_id}
 */
export async function deleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId(
  project_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['project_id'],
  shift_report_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['shift_report_id'],
  document_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['document_id'],
  resource_type: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['resource_type'],
  resource_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdPathParamsSchema['resource_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdShiftReportsShiftReportIdResourceTypeResourceIdDocumentsDocumentIdUrl(
      project_id,
      shift_report_id,
      document_id,
      resource_type,
      resource_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindUrl(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['shift_report_id'],
  kind: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['kind']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/resources/${kind}` as const,
  };
  return res;
}

/**
 * @summary Retrieves resources
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/resources/:kind}
 */
export async function getApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['shift_report_id'],
  kind: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['kind'],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindUrl(
      project_id,
      shift_report_id,
      kind
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['shift_report_id'],
  kind: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['kind']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/resources/${kind}` as const,
  };
  return res;
}

/**
 * @summary Create resource
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/resources/:kind}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['shift_report_id'],
  kind: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindPathParamsSchema['kind'],
  data: PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKind422Schema
    >,
    PostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdResourcesKindUrl(
      project_id,
      shift_report_id,
      kind
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsCompletionsUrl(
  project_id: GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/completions` as const,
  };
  return res;
}

/**
 * @summary Retrieves published shift reports
 * {@link /api/projects/:project_id/shift_reports/completions}
 */
export async function getApiProjectsProjectIdShiftReportsCompletions(
  project_id: GetApiProjectsProjectIdShiftReportsCompletionsPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsCompletionsQueryResponseSchema,
    ResponseErrorConfig<
      GetApiProjectsProjectIdShiftReportsCompletions401Schema | GetApiProjectsProjectIdShiftReportsCompletions403Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsCompletionsUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsUrl(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/quality_indicators` as const,
  };
  return res;
}

/**
 * @summary Retrieves all quality indicators for a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/quality_indicators}
 */
export async function getApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsPathParamsSchema['shift_report_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicators404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsShiftReportIdQualityIndicatorsUrl(
      project_id,
      shift_report_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsUrl(
  project_id: GetApiProjectsProjectIdShiftReportsPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports` as const,
  };
  return res;
}

/**
 * @summary Retrieves published shift reports
 * {@link /api/projects/:project_id/shift_reports}
 */
export async function getApiProjectsProjectIdShiftReports(
  project_id: GetApiProjectsProjectIdShiftReportsPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdShiftReportsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReports400Schema
      | GetApiProjectsProjectIdShiftReports401Schema
      | GetApiProjectsProjectIdShiftReports403Schema
      | GetApiProjectsProjectIdShiftReports404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsUrl(
  project_id: PostApiProjectsProjectIdShiftReportsPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports` as const,
  };
  return res;
}

/**
 * @summary Creates a shift report
 * {@link /api/projects/:project_id/shift_reports}
 */
export async function postApiProjectsProjectIdShiftReports(
  project_id: PostApiProjectsProjectIdShiftReportsPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdShiftReportsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdShiftReportsMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReports401Schema
      | PostApiProjectsProjectIdShiftReports403Schema
      | PostApiProjectsProjectIdShiftReports404Schema
      | PostApiProjectsProjectIdShiftReports422Schema
    >,
    PostApiProjectsProjectIdShiftReportsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsArchivedUrl(
  project_id: GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/archived` as const,
  };
  return res;
}

/**
 * @summary Retrieves archived shift reports
 * {@link /api/projects/:project_id/shift_reports/archived}
 */
export async function getApiProjectsProjectIdShiftReportsArchived(
  project_id: GetApiProjectsProjectIdShiftReportsArchivedPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdShiftReportsArchivedQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsArchivedQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsArchived400Schema
      | GetApiProjectsProjectIdShiftReportsArchived401Schema
      | GetApiProjectsProjectIdShiftReportsArchived403Schema
      | GetApiProjectsProjectIdShiftReportsArchived404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsArchivedUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsDraftUrl(
  project_id: GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/draft` as const,
  };
  return res;
}

/**
 * @summary Retrieves draft shift reports where the user is an owner or a collaborator
 * {@link /api/projects/:project_id/shift_reports/draft}
 */
export async function getApiProjectsProjectIdShiftReportsDraft(
  project_id: GetApiProjectsProjectIdShiftReportsDraftPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdShiftReportsDraftQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsDraftQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsDraft400Schema
      | GetApiProjectsProjectIdShiftReportsDraft401Schema
      | GetApiProjectsProjectIdShiftReportsDraft403Schema
      | GetApiProjectsProjectIdShiftReportsDraft404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsDraftUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsInReviewUrl(
  project_id: GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/in_review` as const,
  };
  return res;
}

/**
 * @summary Retrieves in_review shift reports where the user is an owner, approver, or a collaborator
 * {@link /api/projects/:project_id/shift_reports/in_review}
 */
export async function getApiProjectsProjectIdShiftReportsInReview(
  project_id: GetApiProjectsProjectIdShiftReportsInReviewPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdShiftReportsInReviewQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsInReviewQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsInReview400Schema
      | GetApiProjectsProjectIdShiftReportsInReview401Schema
      | GetApiProjectsProjectIdShiftReportsInReview403Schema
      | GetApiProjectsProjectIdShiftReportsInReview404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsInReviewUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsShiftReportIdUrl(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id}
 */
export async function getApiProjectsProjectIdShiftReportsShiftReportId(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['shift_report_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsShiftReportIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsShiftReportIdUrl(project_id, shift_report_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdShiftReportsShiftReportIdUrl(
  project_id: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['project_id'],
  shift_report_id: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a shift report not published
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id}
 */
export async function patchApiProjectsProjectIdShiftReportsShiftReportId(
  project_id: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['project_id'],
  shift_report_id: PatchApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['shift_report_id'],
  data?: PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdShiftReportsShiftReportId400Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId404Schema
      | PatchApiProjectsProjectIdShiftReportsShiftReportId422Schema
    >,
    PatchApiProjectsProjectIdShiftReportsShiftReportIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdShiftReportsShiftReportIdUrl(project_id, shift_report_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdShiftReportsShiftReportIdUrl(
  project_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['project_id'],
  shift_report_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a shift report not published
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id}
 */
export async function deleteApiProjectsProjectIdShiftReportsShiftReportId(
  project_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['project_id'],
  shift_report_id: DeleteApiProjectsProjectIdShiftReportsShiftReportIdPathParamsSchema['shift_report_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdShiftReportsShiftReportIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId400Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId401Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId403Schema
      | DeleteApiProjectsProjectIdShiftReportsShiftReportId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdShiftReportsShiftReportIdUrl(project_id, shift_report_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdArchiveUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/archive` as const,
  };
  return res;
}

/**
 * @summary Archives a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/archive}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdArchive(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdArchivePathParamsSchema['shift_report_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdArchive422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdArchiveUrl(project_id, shift_report_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersUrl(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/progress_logs/counters` as const,
  };
  return res;
}

/**
 * @summary Retrieves progress log counters for a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/progress_logs/counters}
 */
export async function getApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters(
  project_id: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema['project_id'],
  shift_report_id: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersPathParamsSchema['shift_report_id'],
  params?: GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters401Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters403Schema
      | GetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCounters404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdShiftReportsShiftReportIdProgressLogsCountersUrl(
      project_id,
      shift_report_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdPublishUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/publish` as const,
  };
  return res;
}

/**
 * @summary Publishes a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/publish}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdPublish(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishPathParamsSchema['shift_report_id'],
  params?: PostApiProjectsProjectIdShiftReportsShiftReportIdPublishQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdPublishMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdPublish404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdPublishUrl(project_id, shift_report_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/reset_section` as const,
  };
  return res;
}

/**
 * @summary Deletes all elements from a shift report section
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/reset_section}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdResetSection(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionPathParamsSchema['shift_report_id'],
  params?: PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdResetSection403Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdResetSectionUrl(
      project_id,
      shift_report_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdRestoreUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/restore` as const,
  };
  return res;
}

/**
 * @summary Restores a shift report
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/restore}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdRestore(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdRestorePathParamsSchema['shift_report_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore404Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdRestore422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdRestoreUrl(project_id, shift_report_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewUrl(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema['shift_report_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/shift_reports/${shift_report_id}/submit_for_review` as const,
  };
  return res;
}

/**
 * @summary Submits a draft shift report to review
 * {@link /api/projects/:project_id/shift_reports/:shift_report_id/submit_for_review}
 */
export async function postApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview(
  project_id: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema['project_id'],
  shift_report_id: PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewPathParamsSchema['shift_report_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview400Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview401Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview403Schema
      | PostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReview404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdShiftReportsShiftReportIdSubmitForReviewUrl(
      project_id,
      shift_report_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsShowcasesUrl() {
  const res = { method: 'POST', url: `/api/projects/showcases` as const };
  return res;
}

/**
 * @summary Creates a Showcase project
 * {@link /api/projects/showcases}
 */
export async function postApiProjectsShowcases(
  data: PostApiProjectsShowcasesMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsShowcasesMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsShowcasesMutationResponseSchema,
    ResponseErrorConfig<PostApiProjectsShowcases401Schema | PostApiProjectsShowcases403Schema>,
    PostApiProjectsShowcasesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsShowcasesUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdTeamsTeamIdChannelConfigurationUrl(
  project_id: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema['team_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/teams/${team_id}/channel_configuration` as const,
  };
  return res;
}

/**
 * @summary Retrieves the team channel configuration
 * {@link /api/projects/:project_id/teams/:team_id/channel_configuration}
 */
export async function getApiProjectsProjectIdTeamsTeamIdChannelConfiguration(
  project_id: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema['team_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdTeamsTeamIdChannelConfigurationQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
      | GetApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdTeamsTeamIdChannelConfigurationUrl(project_id, team_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationUrl(
  project_id: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema['project_id'],
  team_id: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema['team_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/teams/${team_id}/channel_configuration` as const,
  };
  return res;
}

/**
 * @summary Updates the team channel configuration
 * {@link /api/projects/:project_id/teams/:team_id/channel_configuration}
 */
export async function patchApiProjectsProjectIdTeamsTeamIdChannelConfiguration(
  project_id: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema['project_id'],
  team_id: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationPathParamsSchema['team_id'],
  data?: PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration401Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration403Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration404Schema
      | PatchApiProjectsProjectIdTeamsTeamIdChannelConfiguration422Schema
    >,
    PatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdTeamsTeamIdChannelConfigurationUrl(project_id, team_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdTeamsTeamIdJoinTokenUrl(
  project_id: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['team_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/teams/${team_id}/join_token` as const,
  };
  return res;
}

/**
 * @summary Retrieves a team join token
 * {@link /api/projects/:project_id/teams/:team_id/join_token}
 */
export async function getApiProjectsProjectIdTeamsTeamIdJoinToken(
  project_id: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['team_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdTeamsTeamIdJoinTokenQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | GetApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdTeamsTeamIdJoinTokenUrl(project_id, team_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdJoinTokenUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['team_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/join_token` as const,
  };
  return res;
}

/**
 * @summary Creates a new team join token (and expires existing join token)
 * {@link /api/projects/:project_id/teams/:team_id/join_token}
 */
export async function postApiProjectsProjectIdTeamsTeamIdJoinToken(
  project_id: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['team_id'],
  data: PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
      | PostApiProjectsProjectIdTeamsTeamIdJoinToken422Schema
    >,
    PostApiProjectsProjectIdTeamsTeamIdJoinTokenMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdJoinTokenUrl(project_id, team_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdTeamsTeamIdJoinTokenUrl(
  project_id: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['project_id'],
  team_id: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['team_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/teams/${team_id}/join_token` as const,
  };
  return res;
}

/**
 * @summary Expires a team join token
 * {@link /api/projects/:project_id/teams/:team_id/join_token}
 */
export async function deleteApiProjectsProjectIdTeamsTeamIdJoinToken(
  project_id: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['project_id'],
  team_id: DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenPathParamsSchema['team_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdTeamsTeamIdJoinTokenMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken401Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken403Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdJoinToken404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdTeamsTeamIdJoinTokenUrl(project_id, team_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdTeamJoinTokensTokenUrl(
  project_id: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema['project_id'],
  token: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema['token']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/team_join_tokens/${token}` as const,
  };
  return res;
}

/**
 * @summary Retrieves public team join token
 * {@link /api/projects/:project_id/team_join_tokens/:token}
 */
export async function getApiProjectsProjectIdTeamJoinTokensToken(
  project_id: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema['project_id'],
  token: GetApiProjectsProjectIdTeamJoinTokensTokenPathParamsSchema['token'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdTeamJoinTokensTokenQueryResponseSchema,
    ResponseErrorConfig<GetApiProjectsProjectIdTeamJoinTokensToken404Schema>,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdTeamJoinTokensTokenUrl(project_id, token).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamJoinTokensTokenJoinUrl(
  project_id: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema['project_id'],
  token: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema['token']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/team_join_tokens/${token}/join` as const,
  };
  return res;
}

/**
 * @summary Adds a user to a team using a team join token
 * {@link /api/projects/:project_id/team_join_tokens/:token/join}
 */
export async function postApiProjectsProjectIdTeamJoinTokensTokenJoin(
  project_id: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema['project_id'],
  token: PostApiProjectsProjectIdTeamJoinTokensTokenJoinPathParamsSchema['token'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdTeamJoinTokensTokenJoinMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin401Schema
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin404Schema
      | PostApiProjectsProjectIdTeamJoinTokensTokenJoin422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamJoinTokensTokenJoinUrl(project_id, token).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdMembersUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema['team_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/members` as const,
  };
  return res;
}

/**
 * @summary Invites a user to the team
 * {@link /api/projects/:project_id/teams/:team_id/members}
 */
export async function postApiProjectsProjectIdTeamsTeamIdMembers(
  project_id: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdMembersPathParamsSchema['team_id'],
  data?: PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdMembersMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembers401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers404Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembers422Schema
    >,
    PostApiProjectsProjectIdTeamsTeamIdMembersMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdMembersUrl(project_id, team_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdUrl(
  project_id: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['project_id'],
  team_id: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['team_id'],
  team_member_id: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['team_member_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/teams/${team_id}/members/${team_member_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a team member
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id}
 */
export async function patchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId(
  project_id: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['project_id'],
  team_id: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['team_id'],
  team_member_id: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['team_member_id'],
  data?: PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
      | PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId422Schema
    >,
    PatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdUrl(
      project_id,
      team_id,
      team_member_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdUrl(
  project_id: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['project_id'],
  team_id: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['team_id'],
  team_member_id: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['team_member_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/teams/${team_id}/members/${team_member_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes an invited team member
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id}
 */
export async function deleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId(
  project_id: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['project_id'],
  team_id: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['team_id'],
  team_member_id: DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdPathParamsSchema['team_member_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId401Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId403Schema
      | DeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdUrl(
      project_id,
      team_id,
      team_member_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema['team_id'],
  team_member_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema['team_member_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/members/${team_member_id}/archive` as const,
  };
  return res;
}

/**
 * @summary Archives a team member
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id/archive}
 */
export async function postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive(
  project_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema['team_id'],
  team_member_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchivePathParamsSchema['team_member_id'],
  data?: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive404Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchive422Schema
    >,
    PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdArchiveUrl(
      project_id,
      team_id,
      team_member_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesUrl(
  project_id: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema['team_id'],
  team_member_id: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema['team_member_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/teams/${team_id}/members/${team_member_id}/issue_dependencies` as const,
  };
  return res;
}

/**
 * @summary Retrieves team member issue dependencies
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id/issue_dependencies}
 */
export async function getApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies(
  project_id: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema['team_id'],
  team_member_id: GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesPathParamsSchema['team_member_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies401Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies403Schema
      | GetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependencies404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdIssueDependenciesUrl(
      project_id,
      team_id,
      team_member_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema['team_id'],
  team_member_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema['team_member_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/members/${team_member_id}/resend_invite_email` as const,
  };
  return res;
}

/**
 * @summary Resends invite email to an invited user
 * {@link /api/projects/:project_id/teams/:team_id/members/:team_member_id/resend_invite_email}
 */
export async function postApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail(
  project_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema['team_id'],
  team_member_id: PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailPathParamsSchema['team_member_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail401Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail403Schema
      | PostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmail404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdMembersTeamMemberIdResendInviteEmailUrl(
      project_id,
      team_id,
      team_member_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema['team_id'],
  resource_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema['resource_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/resources/${resource_id}/enable` as const,
  };
  return res;
}

/**
 * @summary Enables a resource
 * {@link /api/projects/:project_id/teams/:team_id/resources/:resource_id/enable}
 */
export async function postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable(
  project_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema['team_id'],
  resource_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnablePathParamsSchema['resource_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnable404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdEnableUrl(
      project_id,
      team_id,
      resource_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema['team_id'],
  resource_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema['resource_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/resources/${resource_id}/disable` as const,
  };
  return res;
}

/**
 * @summary Disables a resource
 * {@link /api/projects/:project_id/teams/:team_id/resources/:resource_id/disable}
 */
export async function postApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable(
  project_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema['team_id'],
  resource_id: PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisablePathParamsSchema['resource_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisable404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdResourcesResourceIdDisableUrl(
      project_id,
      team_id,
      resource_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdTeamsTeamIdResourcesKindUrl(
  project_id: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['team_id'],
  kind: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['kind']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/teams/${team_id}/resources/${kind}` as const,
  };
  return res;
}

/**
 * @summary Retrieves resources
 * {@link /api/projects/:project_id/teams/:team_id/resources/:kind}
 */
export async function getApiProjectsProjectIdTeamsTeamIdResourcesKind(
  project_id: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['team_id'],
  kind: GetApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['kind'],
  params?: GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdTeamsTeamIdResourcesKindQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
      | GetApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdTeamsTeamIdResourcesKindUrl(project_id, team_id, kind).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdResourcesKindUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['team_id'],
  kind: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['kind']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/resources/${kind}` as const,
  };
  return res;
}

/**
 * @summary Create resource
 * {@link /api/projects/:project_id/teams/:team_id/resources/:kind}
 */
export async function postApiProjectsProjectIdTeamsTeamIdResourcesKind(
  project_id: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['team_id'],
  kind: PostApiProjectsProjectIdTeamsTeamIdResourcesKindPathParamsSchema['kind'],
  data: PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind404Schema
      | PostApiProjectsProjectIdTeamsTeamIdResourcesKind422Schema
    >,
    PostApiProjectsProjectIdTeamsTeamIdResourcesKindMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdResourcesKindUrl(project_id, team_id, kind).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanUrl(
  project_id: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema['team_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/teams/${team_id}/subscription_plan` as const,
  };
  return res;
}

/**
 * @summary Retrieves team current subscription plan
 * {@link /api/projects/:project_id/teams/:team_id/subscription_plan}
 */
export async function getApiProjectsProjectIdTeamsTeamIdSubscriptionPlan(
  project_id: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanPathParamsSchema['team_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan401Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan403Schema
      | GetApiProjectsProjectIdTeamsTeamIdSubscriptionPlan404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdTeamsTeamIdSubscriptionPlanUrl(project_id, team_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdSubscriptionUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema['team_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/subscription` as const,
  };
  return res;
}

/**
 * @summary Start a team subscription update
 * {@link /api/projects/:project_id/teams/:team_id/subscription}
 */
export async function postApiProjectsProjectIdTeamsTeamIdSubscription(
  project_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionPathParamsSchema['team_id'],
  data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscription401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscription422Schema
    >,
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdSubscriptionUrl(project_id, team_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema['team_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/subscription/confirm` as const,
  };
  return res;
}

/**
 * @summary Confirm a Stripe Billing subscription
 * {@link /api/projects/:project_id/teams/:team_id/subscription/confirm}
 */
export async function postApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm(
  project_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmPathParamsSchema['team_id'],
  data?: PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirm422Schema
    >,
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdSubscriptionConfirmUrl(project_id, team_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema['team_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/subscription/billing_portal` as const,
  };
  return res;
}

/**
 * @summary Retrieves an URL for the billing portal
 * {@link /api/projects/:project_id/teams/:team_id/subscription/billing_portal}
 */
export async function postApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal(
  project_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalPathParamsSchema['team_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal401Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal403Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal404Schema
      | PostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortal422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdSubscriptionBillingPortalUrl(project_id, team_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdTeamsUrl(project_id: GetApiProjectsProjectIdTeamsPathParamsSchema['project_id']) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/teams` as const,
  };
  return res;
}

/**
 * @summary Retrieves teams
 * {@link /api/projects/:project_id/teams}
 */
export async function getApiProjectsProjectIdTeams(
  project_id: GetApiProjectsProjectIdTeamsPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdTeamsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeams401Schema
      | GetApiProjectsProjectIdTeams403Schema
      | GetApiProjectsProjectIdTeams404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdTeamsUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsUrl(project_id: PostApiProjectsProjectIdTeamsPathParamsSchema['project_id']) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams` as const,
  };
  return res;
}

/**
 * @summary Creates a team
 * {@link /api/projects/:project_id/teams}
 */
export async function postApiProjectsProjectIdTeams(
  project_id: PostApiProjectsProjectIdTeamsPathParamsSchema['project_id'],
  data?: PostApiProjectsProjectIdTeamsMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdTeamsMutationRequestSchema>> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdTeamsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeams401Schema
      | PostApiProjectsProjectIdTeams403Schema
      | PostApiProjectsProjectIdTeams404Schema
      | PostApiProjectsProjectIdTeams422Schema
    >,
    PostApiProjectsProjectIdTeamsMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdTeamsTeamIdUrl(
  project_id: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema['team_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/teams/${team_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a team
 * {@link /api/projects/:project_id/teams/:team_id}
 */
export async function getApiProjectsProjectIdTeamsTeamId(
  project_id: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema['project_id'],
  team_id: GetApiProjectsProjectIdTeamsTeamIdPathParamsSchema['team_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdTeamsTeamIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdTeamsTeamId401Schema
      | GetApiProjectsProjectIdTeamsTeamId403Schema
      | GetApiProjectsProjectIdTeamsTeamId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdTeamsTeamIdUrl(project_id, team_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdTeamsTeamIdUrl(
  project_id: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema['project_id'],
  team_id: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema['team_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/teams/${team_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a team
 * {@link /api/projects/:project_id/teams/:team_id}
 */
export async function patchApiProjectsProjectIdTeamsTeamId(
  project_id: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema['project_id'],
  team_id: PatchApiProjectsProjectIdTeamsTeamIdPathParamsSchema['team_id'],
  data?: PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdTeamsTeamId401Schema
      | PatchApiProjectsProjectIdTeamsTeamId403Schema
      | PatchApiProjectsProjectIdTeamsTeamId404Schema
    >,
    PatchApiProjectsProjectIdTeamsTeamIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdTeamsTeamIdUrl(project_id, team_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdTeamsTeamIdUrl(
  project_id: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema['project_id'],
  team_id: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema['team_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/teams/${team_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a team
 * {@link /api/projects/:project_id/teams/:team_id}
 */
export async function deleteApiProjectsProjectIdTeamsTeamId(
  project_id: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema['project_id'],
  team_id: DeleteApiProjectsProjectIdTeamsTeamIdPathParamsSchema['team_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdTeamsTeamIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdTeamsTeamId401Schema
      | DeleteApiProjectsProjectIdTeamsTeamId403Schema
      | DeleteApiProjectsProjectIdTeamsTeamId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdTeamsTeamIdUrl(project_id, team_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesUrl(
  project_id: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema['team_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/teams/${team_id}/resend_members_invites` as const,
  };
  return res;
}

/**
 * @summary Resends invite email to all invited users on the team
 * {@link /api/projects/:project_id/teams/:team_id/resend_members_invites}
 */
export async function postApiProjectsProjectIdTeamsTeamIdResendMembersInvites(
  project_id: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema['project_id'],
  team_id: PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesPathParamsSchema['team_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites401Schema
      | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites403Schema
      | PostApiProjectsProjectIdTeamsTeamIdResendMembersInvites404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdTeamsTeamIdResendMembersInvitesUrl(project_id, team_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdIssuesIssueIdWatchingsUrl(
  project_id: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/issues/${issue_id}/watchings` as const,
  };
  return res;
}

/**
 * @summary Retrieves issue watchings
 * {@link /api/projects/:project_id/issues/:issue_id/watchings}
 */
export async function getApiProjectsProjectIdIssuesIssueIdWatchings(
  project_id: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['project_id'],
  issue_id: GetApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdIssuesIssueIdWatchingsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | GetApiProjectsProjectIdIssuesIssueIdWatchings403Schema
      | GetApiProjectsProjectIdIssuesIssueIdWatchings404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdIssuesIssueIdWatchingsUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdWatchingsUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/watchings` as const,
  };
  return res;
}

/**
 * @summary Watches an issue
 * {@link /api/projects/:project_id/issues/:issue_id/watchings}
 */
export async function postApiProjectsProjectIdIssuesIssueIdWatchings(
  project_id: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings403Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings404Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchings422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdWatchingsUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdIssuesIssueIdWatchingsUrl(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['issue_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/issues/${issue_id}/watchings` as const,
  };
  return res;
}

/**
 * @summary Unwatches an issue
 * {@link /api/projects/:project_id/issues/:issue_id/watchings}
 */
export async function deleteApiProjectsProjectIdIssuesIssueIdWatchings(
  project_id: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['project_id'],
  issue_id: DeleteApiProjectsProjectIdIssuesIssueIdWatchingsPathParamsSchema['issue_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdIssuesIssueIdWatchingsMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings401Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings404Schema
      | DeleteApiProjectsProjectIdIssuesIssueIdWatchings422Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdIssuesIssueIdWatchingsUrl(project_id, issue_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateUrl(
  project_id: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema['issue_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/issues/${issue_id}/watchings/batch_create` as const,
  };
  return res;
}

/**
 * @summary Creates issue watchings
 * {@link /api/projects/:project_id/issues/:issue_id/watchings/batch_create}
 */
export async function postApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate(
  project_id: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema['project_id'],
  issue_id: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreatePathParamsSchema['issue_id'],
  data: PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate401Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate403Schema
      | PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreate422Schema
    >,
    PostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdIssuesIssueIdWatchingsBatchCreateUrl(project_id, issue_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesUrl(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema['project_id'],
  weekly_work_plan_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/activities` as const,
  };
  return res;
}

/**
 * @summary Retrieves a weekly work plan activities
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities}
 */
export async function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema['project_id'],
  weekly_work_plan_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema['weekly_work_plan_id'],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/activities` as const,
  };
  return res;
}

/**
 * @summary Creates a weekly work plan activity
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesPathParamsSchema['weekly_work_plan_id'],
  data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivities422Schema
    >,
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/activities/batch` as const,
  };
  return res;
}

/**
 * @summary Creates a batch of weekly work plan activities
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/batch}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchPathParamsSchema['weekly_work_plan_id'],
  data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatch404Schema
    >,
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesBatchUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdUrl(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['project_id'],
  weekly_work_plan_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['weekly_work_plan_id'],
  activity_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['activity_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/activities/${activity_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a weekly work plan activity
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id}
 */
export async function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['project_id'],
  weekly_work_plan_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['weekly_work_plan_id'],
  activity_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdUrl(
      project_id,
      weekly_work_plan_id,
      activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdUrl(
  project_id: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['project_id'],
  weekly_work_plan_id: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['weekly_work_plan_id'],
  activity_id: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['activity_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/activities/${activity_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a weekly work plan activity
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id}
 */
export async function patchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId(
  project_id: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['project_id'],
  weekly_work_plan_id: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['weekly_work_plan_id'],
  activity_id: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['activity_id'],
  data?: PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema,
  config: Partial<
    RequestConfig<PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId422Schema
    >,
    PatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdUrl(
      project_id,
      weekly_work_plan_id,
      activity_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdUrl(
  project_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['project_id'],
  weekly_work_plan_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['weekly_work_plan_id'],
  activity_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['activity_id']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/activities/${activity_id}` as const,
  };
  return res;
}

/**
 * @summary Deletes a weekly work plan activity
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id}
 */
export async function deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId(
  project_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['project_id'],
  weekly_work_plan_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['weekly_work_plan_id'],
  activity_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdPathParamsSchema['activity_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId401Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId403Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityId404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdUrl(
      project_id,
      weekly_work_plan_id,
      activity_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/activities/sort` as const,
  };
  return res;
}

/**
 * @summary Sorts weekly work plan activities
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/sort}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortPathParamsSchema['weekly_work_plan_id'],
  data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSort404Schema
    >,
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesSortUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema['weekly_work_plan_id'],
  activity_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema['activity_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/activities/${activity_id}/scheduled_days` as const,
  };
  return res;
}

/**
 * @summary Creates a weekly work plan activity scheduled day
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id/scheduled_days}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema['weekly_work_plan_id'],
  activity_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysPathParamsSchema['activity_id'],
  data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDays422Schema
    >,
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysUrl(
      project_id,
      weekly_work_plan_id,
      activity_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getDeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateUrl(
  project_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema['project_id'],
  weekly_work_plan_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema['weekly_work_plan_id'],
  activity_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema['activity_id'],
  date: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema['date']
) {
  const res = {
    method: 'DELETE',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/activities/${activity_id}/scheduled_days/${date}` as const,
  };
  return res;
}

/**
 * @summary Deletes a weekly work plan activity scheduled day
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/activities/:activity_id/scheduled_days/:date}
 */
export async function deleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate(
  project_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema['project_id'],
  weekly_work_plan_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema['weekly_work_plan_id'],
  activity_id: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema['activity_id'],
  date: DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDatePathParamsSchema['date'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateMutationResponseSchema,
    ResponseErrorConfig<
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate401Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate403Schema
      | DeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDate404Schema
    >,
    unknown
  >({
    method: 'DELETE',
    url: getDeleteApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdActivitiesActivityIdScheduledDaysDateUrl(
      project_id,
      weekly_work_plan_id,
      activity_id,
      date
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsUrl(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema['project_id'],
  weekly_work_plan_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/progress_logs` as const,
  };
  return res;
}

/**
 * @summary Retrieves a weekly work plan progress logs
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/progress_logs}
 */
export async function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema['project_id'],
  weekly_work_plan_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsPathParamsSchema['weekly_work_plan_id'],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogs404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdProgressLogsUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderUrl(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/weekly_work_plans/shift_activities_finder` as const,
  };
  return res;
}

/**
 * @summary Retrieves shift activities finder options for weekly work plans
 * {@link /api/projects/:project_id/weekly_work_plans/shift_activities_finder}
 */
export async function getApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema['project_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderUrl(project_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderUrl(
  project_id: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema['project_id']
) {
  const res = {
    method: 'PATCH',
    url: `/api/projects/${project_id}/weekly_work_plans/shift_activities_finder` as const,
  };
  return res;
}

/**
 * @summary Updates shift activities finder options for weekly work plans
 * {@link /api/projects/:project_id/weekly_work_plans/shift_activities_finder}
 */
export async function patchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder(
  project_id: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderPathParamsSchema['project_id'],
  data: PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema,
  config: Partial<RequestConfig<PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationResponseSchema,
    ResponseErrorConfig<
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder401Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder403Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder404Schema
      | PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinder422Schema
    >,
    PatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderMutationRequestSchema
  >({
    method: 'PATCH',
    url: getPatchApiProjectsProjectIdWeeklyWorkPlansShiftActivitiesFinderUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdWeeklyWorkPlansUrl(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema['project_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/weekly_work_plans` as const,
  };
  return res;
}

/**
 * @summary Retrieves all team weekly work plans
 * {@link /api/projects/:project_id/weekly_work_plans}
 */
export async function getApiProjectsProjectIdWeeklyWorkPlans(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema['project_id'],
  params?: GetApiProjectsProjectIdWeeklyWorkPlansQueryParamsSchema,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdWeeklyWorkPlansQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlans400Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlans404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdWeeklyWorkPlansUrl(project_id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema['project_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans` as const,
  };
  return res;
}

/**
 * @summary Creates a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlans(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansPathParamsSchema['project_id'],
  data: PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema,
  config: Partial<RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlans400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlans422Schema
    >,
    PostApiProjectsProjectIdWeeklyWorkPlansMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansUrl(project_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdUrl(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema['project_id'],
  weekly_work_plan_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'GET',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}` as const,
  };
  return res;
}

/**
 * @summary Retrieves a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id}
 */
export async function getApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId(
  project_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema['project_id'],
  weekly_work_plan_id: GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema['weekly_work_plan_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdQueryResponseSchema,
    ResponseErrorConfig<
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
      | GetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
    >,
    unknown
  >({
    method: 'GET',
    url: getGetApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdUrl(project_id, weekly_work_plan_id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdUrl(
  project_id: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema['project_id'],
  weekly_work_plan_id: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'PUT',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}` as const,
  };
  return res;
}

/**
 * @summary Updates a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id}
 */
export async function putApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId(
  project_id: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema['project_id'],
  weekly_work_plan_id: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPathParamsSchema['weekly_work_plan_id'],
  data?: PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema,
  config: Partial<RequestConfig<PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema>> & {
    client?: typeof fetch;
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationResponseSchema,
    ResponseErrorConfig<
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId400Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId401Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId403Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId404Schema
      | PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanId422Schema
    >,
    PutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdMutationRequestSchema
  >({
    method: 'PUT',
    url: getPutApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdUrl(project_id, weekly_work_plan_id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/close` as const,
  };
  return res;
}

/**
 * @summary Closes a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/close}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClosePathParamsSchema['weekly_work_plan_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdClose422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdCloseUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/duplicate` as const,
  };
  return res;
}

/**
 * @summary Duplicates the weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/duplicate}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicatePathParamsSchema['weekly_work_plan_id'],
  data?: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicate422Schema
    >,
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdDuplicateUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/prefill` as const,
  };
  return res;
}

/**
 * @summary Prefills the weekly work plan (and deletes existing activities)
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/prefill}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillPathParamsSchema['weekly_work_plan_id'],
  data: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema,
  config: Partial<
    RequestConfig<PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema>
  > & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill400Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefill422Schema
    >,
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillMutationRequestSchema
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPrefillUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/export` as const,
  };
  return res;
}

/**
 * @summary Requests a weekly work plan export
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/export}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportPathParamsSchema['weekly_work_plan_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExport404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdExportUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/lookback/export` as const,
  };
  return res;
}

/**
 * @summary Requests a weekly work plan lookback export
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/lookback/export}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportPathParamsSchema['weekly_work_plan_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExport404Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdLookbackExportUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/publish` as const,
  };
  return res;
}

/**
 * @summary Publishes a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/publish}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishPathParamsSchema['weekly_work_plan_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublish422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdPublishUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/archive` as const,
  };
  return res;
}

/**
 * @summary Archives a weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/archive}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchivePathParamsSchema['weekly_work_plan_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchive422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdArchiveUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}

function getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreUrl(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema['weekly_work_plan_id']
) {
  const res = {
    method: 'POST',
    url: `/api/projects/${project_id}/weekly_work_plans/${weekly_work_plan_id}/restore` as const,
  };
  return res;
}

/**
 * @summary Restores an archived weekly work plan
 * {@link /api/projects/:project_id/weekly_work_plans/:weekly_work_plan_id/restore}
 */
export async function postApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore(
  project_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema['project_id'],
  weekly_work_plan_id: PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestorePathParamsSchema['weekly_work_plan_id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreMutationResponseSchema,
    ResponseErrorConfig<
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore401Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore403Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore404Schema
      | PostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestore422Schema
    >,
    unknown
  >({
    method: 'POST',
    url: getPostApiProjectsProjectIdWeeklyWorkPlansWeeklyWorkPlanIdRestoreUrl(
      project_id,
      weekly_work_plan_id
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
